import {ResponsiveService} from '../../../../../../core/services/responsive.service';
import {SCREEN_SIZE} from '../../../../../../core/constants/screen-size';
// @ts-ignore
import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  AfterViewInit,
  ViewChildren,
  QueryList,
  ChangeDetectorRef
} from '@angular/core';
import {DigitalCertificateService} from 'src/app/core/services/digital-certificate.service';
import {DomSanitizer} from '@angular/platform-browser';
// @ts-ignore
import {NzUploadFile} from 'ng-zorro-antd/upload';
import {ToastrService} from 'ngx-toastr';
import {Message} from 'src/app/core/class/message';
import {SignDocumentComponent} from '../sign-document/sign-document.component';
import {CommonService} from 'src/app/core/services/common.service';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {SignDocumentService} from 'src/app/core/services/sign-document.service';
import {ConfirmSignOtpWithImageComponent} from '../confirm-sign-otp-with-image/confirm-sign-otp-with-image.component';
import {BreadcrumbsService} from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import {MatDialog} from '@angular/material/dialog';
import { format } from 'date-fns';
import {SigningDialogComponent} from 'src/app/modules/dashboard/home/home-enterprise/document/signing-dialog/signing-dialog.component';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {CertificateType, CertificateTypeID, Common} from 'src/app/core/constants/common';
import {AddDigitalCertificateComponent} from '../../digital-certificate/add-digital-certificate/add-digital-certificate.component';
import {DocumentService} from 'src/app/core/services/document.service';
import {CanvasService} from 'src/app/core/services/canvas.service';
import {CanvasComponent} from 'src/app/shared/components/canvas/canvas.component';
import {AlertComponent} from '../../../../../../shared/components/alert/alert.component';
import {ApiService} from 'src/app/core/services/api.service';
import {ErrorCode} from 'src/app/core/constants/error-code';
import {NotificationService} from 'src/app/core/services/notification.service';
import {pdfDefaultOptions} from 'ngx-extended-pdf-viewer';
import {UsbTokenService} from '../../../../../../core/services/usb-token.service';
import {BehaviorSubject, forkJoin, Observable, of, Subject, Subscription} from 'rxjs';
import {DeviceDetectorService} from 'ngx-device-detector';
import {SignPositionTypes} from '../../../../../../core/constants/signposition-types';
// import {ChangeDeviceComponent} from 'src/app/shared/components/change-device/change-device.component';
import {EkycCameraComponent} from '../ekyc/ekyc-camera/ekyc-camera.component';
import {EnterpriseService} from 'src/app/core/services/enterprise.service';
import {EnterpriseTypes} from 'src/app/core/constants/enterprise-type';
import {catchError, delay, map, switchMap, tap} from 'rxjs/operators';
import {ConfirmResignEkycSupportComponent} from '../confirm-resign-ekyc-support/confirm-resign-ekyc-support.component';
import {EnumContractStatus, EnumSignMethod} from '../../../../../../core/constants/contract';
import * as _ from 'lodash';
import {NotifyWarningComponent} from 'src/app/shared/components/notify-warning/notify-warning.component';
import * as uuid from 'uuid';
import {EnvService} from 'src/app/core/services/env.service';
import {
  imageConfigFormPreviewId,
  imageConfigRenderId,
  imageConfigViewScaleId,
  ImageSignConfigComponent
} from './image-sign-config/image-sign-config.component';
import {SignatureConfig} from './signature-config.model';
import * as htmlToImage from 'html-to-image';
import {AnonymousSubscription} from 'rxjs-compat/Subscription';
import FileUtils from '../../../../../../core/services/file-utils';
import {ImageGenerateService} from "../../../../../../core/services/image-generate.service";


declare var $: any;

declare function signHash(comp, hashBase64): any;

declare function initPlugin(comp): any;

declare function initPluginSign(comp): any;

declare function getSessionId(): any;


declare function initPluginCertificateNormal(comp: any, contracts: any): any;

declare function anonymousSignHash(comp, hashBase64, sessionId, serialNumber): any;

declare function signHashNormal(comp, hashBase64, sessionId, serialNumber): any;

declare function normalSignHash(comp, hashBase64, sessionId, serialNumber): any;

declare function checkPlugin(comp): any;

export interface SelectedCertInterface {
  serialNumber: string,
  phoneNumber: any,
  typeCertificate: any,
  id: any,
  idDetail: any,
  imageUrl: any,
  issuedTo: string,
  taxCode: string,

  [key: string]: any
}

@Component({
  selector: 'app-sign-flow-document',
  templateUrl: './sign-flow-document.component.html',
  styleUrls: ['./sign-flow-document.component.scss']
})
export class SignFlowDocumentComponent implements OnInit, AfterViewInit, OnDestroy {
  // @ts-ignore
  @ViewChild(ImageSignConfigComponent) imageSignConfig: ImageSignConfigComponent;
  // @ts-ignore
  @ViewChild('SignImageConfig', {static: true}) domRenderImage: ElementRef
  countAllApiBeforeCertificateDefault = 0;
  sertificateDefaultOnj: any;
  private isGotoSignpage = false;
  isCertificateDefault = false;
  public listPdfSrc = {};
  public isCancelSign = false;
  contractSignEntityList = []
  signTransactionId: any;
  signImages = [];
  saveImageData = [];
  subscriptions: Subscription = new Subscription();
  isHsmPermission = false
  private destroy$ = new Subject<void>();
  activeTabGenerationId = 0;  // increments on tab change to invalidate pending async operations
  activeAbortCtrl: AbortController | null = null;  // cancels in-flight fetch requests

  isNotAttestedUser: boolean = false;

  signConfig: SignatureConfig = SignatureConfig.build();

  widthImageRender: number = 0;
  heightImageRender: number = 0;
  systemImageSign = false;
  messageSign: string = '';
  canMoveAndResize: boolean = false;
  isShowImage: boolean = true;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private digitalCertificateService: DigitalCertificateService,
    private sanitizer: DomSanitizer,
    private translateService: TranslateService,
    private activeRoute: ActivatedRoute,
    private signDocumentService: SignDocumentService,
    private breadcrumbsService: BreadcrumbsService,
    private documentService: DocumentService,
    private canvasService: CanvasService,
    private apiService: ApiService,
    public notificationService: NotificationService,
    private usbTokenService: UsbTokenService,
    public deviceService: DeviceDetectorService,
    private responsiveService: ResponsiveService,
    private enterpriseService: EnterpriseService,
    private env: EnvService,
    private cd: ChangeDetectorRef,
    private imageGenerateService: ImageGenerateService
  ) {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.isShowSidebarButton = false;
      this.zoomLevel = 50;
    }
    this.userType = Number(localStorage.getItem('userType'));
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.enterpriseName = localStorage.getItem('fullName');
    this.permissions = localStorage.getItem('permissions').match(/\d+/g).map(Number);
    pdfDefaultOptions.renderInteractiveForms = false;
    this.language = localStorage.getItem('__language') || 'vi';
    this.subscribeHash = new BehaviorSubject<string>('');
    this.BASE_URL = env.is_private_app ? env.private_api_endpoint : env.public_api_endpoint;
    this.BASE_URL += '/file/view/contract';
    this.authorization = {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    }
    // this.getButtonsMobile();

    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }

  public language: string;
  private serialNumber: string;
  private sessionId: string;
  private isClickSignBuuton = false;
  private errorStatus: string;
  public isShowSidebarButton = true;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public subcribeViewLandscape: Subscription;
  public subcribePreviewImage: Subscription;
  public subcribePreviewImageUrl: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  imagePreviewWidth: number;
  private imagePreviewHeight: number;
  public signPosition: any[];
  public isAllowSelectSignPosition = true;

  subscribeHash: BehaviorSubject<string>;
  private permissions = [];

  private linkDownSignPlugin(os?: string) {
    let OSName = os;
    if (typeof (os) === 'undefined') {
      if (navigator.appVersion.indexOf("Win") != -1) OSName = "WINDOWS";
      if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MACOS";
      if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX";
      if (navigator.appVersion.indexOf("Linux") != -1) OSName = "LINUX";
    }
    return this.apiService.getBaseUrl() + `/file/download-last-version?os=${OSName}&typeFile=${OSName === "WINDOWS" ? 'exe' : OSName === "LINUX" ? 'deb' : 'pkg'}`;
  };

  isCheckAccessToContract = true;
  private dialogRef: any;

  private leftPosition: number;
  page = 1;
  pageSize: number;
  routeLink: string;
  enterprise: '';
  documentTypeSearch: '';
  nameOrCode: '';
  status: '';
  serviceType: '';
  serviceTypeEntity: any;
  taxCode: '';
  createdUser: '';
  createdTimeFrom: '';
  createdTimeTo: '';
  finishDateFrom: '';
  finishDateTo: '';
  sortDirection: '';
  sortColumn: '';
  goFrom: string;
  public document: any;
  private customerName: '';
  selectedImage: File;
  selectedImageUrl: string | ArrayBuffer;
  isDisableNextButton = true;
  disableSignBtn = true;
  public indexSelect: number = 0;
  openSigningDialog = false;

  private sign: any;
  private contractId: string;
  private certificate = {
    serialNumber: '',
    phoneNumber: undefined,
    typeCertificate: undefined,
    id: undefined,
    idDetail: undefined
  };
  public SIGN_HSM = 4;
  private success: boolean;
  public enterpriseName: string;
  private imageData = [];
  enumSignMethod = EnumSignMethod;
  public isViewLandscape: boolean = false;
  // {
  //     positionY: number;
  //     widthRectangle: number;
  //     pageNumber: string;
  //     pageIndex: number;
  //     stampPositionLeft: number;
  //     zoom: number;
  //     heightRectangle: number;
  //     type: string;
  //     pdfSrc: string;
  //     stampPositionTop: number;
  //     positionX: number,
  //     signType: string
  //   };

  public imageUrlPreview: any;

  private pageIndex = 0;
  private isSelectPosition: any = true;
  private stampWrapper: HTMLDivElement;
  widthRectangle = 300;
  heightRectangle = 136;
  private signPage: any;

  private isSelectDrawImage = false;
  isRenderImage = true;
  private fileUpload: File;
  public loading: boolean;
  public avatarUrl: string;
  signingInteval: any
  current = 0;

  index = 'First-content';
  imageCertificates = [];
  certificates = [];

  typeCertificate: number;
  // public selectedCert = {
  //   serialNumber: '',
  //   phoneNumber: undefined,
  //   typeCertificate: undefined,
  //   id: undefined,
  //   idDetail: undefined,
  //   imageUrl: null,
  //   issuedTo: '',
  //   taxCode: '',
  // };
  selectedCert: SelectedCertInterface = {
    serialNumber: '',
    phoneNumber: undefined,
    typeCertificate: undefined,
    id: undefined,
    idDetail: undefined,
    imageUrl: null,
    issuedTo: '',
    taxCode: '',
  }
  private disableBtnDeleteCanvas: boolean;
  public signMethod = {
    SIGN_SERVER: 0,
    SIGN_USB_TOKEN: 1,
    SIGN_SIM_CA: 2,
    SIGN_OTP: 3,
    // SIGN_HSM: 4,
    // SIGN_IMAGE: 5,
    SIGN_NO_CERT: 6,
    SIGN_EKYC: 7,
    SIGN_EKYC_ADVANCED: 8,
    CLOUD_CA: 10
  };
  // columnsToDisplaySimCA = ['issuedTo', 'serialNumber', 'taxCode', 'phoneNumber', 'expireDate'];
  // columnsToDisplayOther = ['issuedTo', 'serialNumber', 'taxCode', 'expireDate'];
  columnsToDisplaySimCA: string[] = [];

  columnDefinitionsSimCA = [
    {def: 'issuedTo', showXS: true, showSM: true, showMD: true, showLG: true, showXL: true},
    {def: 'serialNumber', showXS: false, showSM: false, showMD: true, showLG: true, showXL: true},
    {def: 'taxCode', showXS: true, showSM: true, showMD: true, showLG: true, showXL: true},
    {def: 'phoneNumber', showXS: false, showSM: false, showMD: true, showLG: true, showXL: true},
    {def: 'expireDate', showXS: true, showSM: true, showMD: true, showLG: true, showXL: true}
  ];


  columnsToDisplayOther: string[] = [];
  columnDefinitionsOther = [
    {def: 'issuedTo', showXS: true, showSM: true, showMD: true, showLG: true, showXL: true},
    {def: 'serialNumber', showXS: false, showSM: false, showMD: true, showLG: true, showXL: true},
    {def: 'taxCode', showXS: false, showSM: false, showMD: true, showLG: true, showXL: true},
    {def: 'expireDate', showXS: true, showSM: true, showMD: true, showLG: true, showXL: true}
  ];

  columnsToDisplayCloudCa: string[] = [];
  columnDefinitionsCloudCa = [
    {def: 'issuedTo', showXS: true, showSM: true, showMD: true, showLG: true, showXL: true},
    {def: 'serialNumber', showXS: false, showSM: false, showMD: true, showLG: true, showXL: true},
    {def: 'taxCode', showXS: false, showSM: false, showMD: true, showLG: true, showXL: true},
    {def: 'cloudCaUsername', showXS: false, showSM: false, showMD: true, showLG: true, showXL: true},
    {def: 'expireDate', showXS: true, showSM: true, showMD: true, showLG: true, showXL: true}
  ];

  private userType: number;
  private enterpriseId: string;
  private selectedIndex: number;
  @Input() public canvasWidth = 660;
  @Input() public canvasHeight = 300;
  pdfSrc: any;
  zoomLevel = 100;
  currentDate = new Date();
  @ViewChild('myCanvas', {static: false}) canvas: ElementRef;
  @ViewChild('navigation', {static: false}) navigation: ElementRef;
  @ViewChild('btnView', {static: false}) private btnView: ElementRef<HTMLElement>;

  // @ts-ignore
  @ViewChild(CanvasComponent) canvasComponent;
  @ViewChild(EkycCameraComponent, {static: false}) private ekyc;


  @BlockUI() blockUI: NgBlockUI;

  DEFAULT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-document/';
  DEFAULT_RECEIVER_ROUTER_ON_BACK_LINK = '/home-enterprise/search-document-receive/';
  SIGN_WAIT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-document-sign';
  APPOVAL_WAIT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-approval-waiting-document';
  INITIAL_WAIT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-initial-waiting-document';
  MY_DOCUMENT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-my-created-document';
  SIGN_WAIT_ROUTER_ON_BACK_LINK_MOHA = '/home-enterprise/approved-contract-moha';
  SIGN_WAIT_ROUTER_ON_BACK_LINK_APPROVED = '/home-enterprise/document-approved-contract';

  thumbnail = [];
  BASE_URL = 'http://localhost:8091/api';
  authorization: any
  beforeUpload = this.commonService.beforeUploadImage;
  isVisible = false;
  dateNow = format(new Date(), 'DD/MM/YYYY');

  isHasPermissionAddCert = false;
  pageCurrent = 1;

  scopeType = 0;

  // define buttons Mobile:
  slidesButtons: any[] = [];
  buttonsDefinitions = [
    {
      id: 1,
      name: 'Hủy bỏ',
      sortOrder: 1,
      functionName: 'this.onClickBtnCancel()',
      icon: 'cancel',
      text: this.message.getMessage('button.cancel'),
      hide: true
    },
    {
      id: 2,
      name: 'Quay lại',
      sortOrder: 2,
      functionName: 'pre()',
      icon: 'arrow_back',
      text: this.message.getMessage('form.back'),
      hide: true
    },
    {
      id: 3,
      name: 'Tiếp theo',
      sortOrder: 3,
      functionName: 'next()',
      icon: 'arrow_forward',
      text: this.message.getMessage('button.next'),
      hide: true
    },
    {
      id: 4,
      name: 'Chuyển đến trang ký',
      sortOrder: 4,
      functionName: 'gotoSignPage()',
      icon: 'pin_drop',
      text: this.message.getMessage('enterprise_contract.buttons.goto_signing_page'),
      hide: true
    },
    {
      id: 5,
      name: 'Chọn lại vị trí',
      sortOrder: 5,
      functionName: 'onStamped()',
      icon: 'replay',
      text: this.message.getMessage('enterprise_contract.buttons.re_select_position'),
      hide: true
    },
    {
      id: 6,
      name: 'Ký',
      sortOrder: 6,
      functionName: 'onClickSignButton()',
      icon: 'gesture',
      text: this.message.getMessage('enterprise_contract.buttons.sign'),
      hide: true
    }
  ];

  slideButtonConfig = {
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    autoplay: false,
    autoplaySpeed: 6000,
    focusOnSelect: false,
  };

  allowOtp = false;
  allowImage = false;
  isPersonalCustomer = false;
  checkCertNumber = false;
  checkName = false;
  checkOtp = false;
  supportEkyc = false;
  isShowEKYC = false;
  enterpriseInfo: any;
  ekycSupportConfig: number = null;
  isStillQuantityEkyc = false;
  certificateTypeID = CertificateTypeID;
  isQuantityEkyc = false;
  isQuantityAdvancedEkyc = false;
  isCertificateSupport = false;
  isReloadCamera = true;

  isSignEkyc = false;
  isSignAdvancedEkyc = false;
  isPassport = false;
  quantityEkyc: number;
  quantityAdvancedEkyc: number;
  userCancel = false
  validateSignNextStep = {
    certificateNo: '',
    representDocumentNumber: '',
    taxCode: ''
  };

  signPositionTypes = SignPositionTypes;
  onlyDigital = false;

  isVisibleMiddle = false;

  fileSrc: any[] = [];
  activeFile: number = 0;
  fileError: string[] = [];
  signPositionCache: any[] = [];
  signProcessing: any[] = [];
  signError: string = null;
  isCancel: boolean = false;
  isCallDone: boolean = false;
  processingId: string = null;
  roleApprover: any;
  isSignDigitalCertificate = false;

  showModalMiddle(): void {
    this.isVisibleMiddle = true;
  }

  handleCancelMiddle(): void {
    this.isVisibleMiddle = false;
  }

  handleOkMiddle(): void {
    if (this.disableBtnDeleteCanvas) {
      this.toastr.error(this.message.getMessage('validation.draw_sign_valid_empty'));
      return;
    }
    this.isVisibleMiddle = false;

    // sau khi vẽ ảnh thì lưu lại lên onSaveCanvas
    if (this.isSelectDrawImage) {
      this.canvasComponent.onSaveCanvas();
    }

    // hiển thị thông báo người dùng chọn vị trí
    if (this.isAllowSelectSignPosition) {
      this.onStamped();
    }

    // console.log("imageUrlPreview: ", this.imageUrlPreview);
    if (this.imageUrlPreview !== null && this.imageUrlPreview !== '' && this.imageUrlPreview !== undefined) {
      this.isDisableNextButton = false;
    } else {
      this.isDisableNextButton = true;
    }
  }

  // ---------- process no image ---------
  handlePreview = async (file: NzUploadFile) => {
    if (!file.url && !file.preview) {
      // tslint:disable-next-line:no-non-null-assertion
      file.preview = await this.commonService.getBase64(file.originFileObj!);
    }
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  onMouseClickPdfViewer() {
    this.isSelectPosition = false;
  }

  pre(): void {
    this.current -= 1;
    this.indexSelect = 0;
    if (this.current < 2) {
      const nodeOther = document.getElementById('show-frames-notification');
      if (nodeOther) {
        nodeOther.remove();
      }
      this.activeFile = 0;
      this.pdfSrc = this.fileSrc.length ? this.fileSrc[0] : null;
      this.isSelectPosition = false;
      this.isAllowSelectSignPosition = false;
    }

    if (this.current === 1) {
      this.avatarUrl = null;
      this.isSelectDrawImage = false;
      this.fileUpload = this.selectedImage;
      this.imageUrlPreview = this.selectedImageUrl;
      if (this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT) {
        this.isDisableNextButton = true;
      }
      this.nzSelectChange(0);
    }
    if (this.current === 0) {
      this.isSelectDrawImage = false;
      this.fileUpload = null;
      this.imageUrlPreview = '';
      this.avatarUrl = null;
      if (this.selectedCert) {
        this.isDisableNextButton = false;
      }
      this.isShowEKYC = false;
    }
    let isShowDefaultTab = this.selectedCert.typeCertificate !== this.signMethod.SIGN_NO_CERT && this.selectedCert.imageUrl;
    const indexUploadTab = isShowDefaultTab ? 2 : 1;
    const indexDrawTab = isShowDefaultTab ? 3 : 2;
    if (this.indexSelect == indexUploadTab || this.indexSelect == indexDrawTab) {
      this.isDisableNextButton = true;
    }
  }

  //   openDialogChangeDevice() {
  //     const link = this.apiService.getHostUrl()
  //     console.log(this.document)
  //     console.log(link)
  //     this.dialogRef = this.dialog.open(ChangeDeviceComponent, {
  //       width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '60%',
  //       maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
  //       minHeight: '250px',
  //       height: 'none',
  //       maxHeight: '100vh',
  //       panelClass: 'scontract-overlay-dialog',
  //       data: {
  //         link,
  //         idDocument: this.document.id
  //       }
  //     });
  //   }
  async next() {
    if (this.selectedCert.phoneNumber) {
      this.signConfig.phoneNumber.value = this.selectedCert.phoneNumber
    }
    // check simCA hoặc Usb token
    if ((this.selectedCert.typeCertificate === CertificateType.USB_TOKEN
      || this.selectedCert.typeCertificate === CertificateType.SIM_CA
      || this.selectedCert.typeCertificate === CertificateType.SIGNATURE_SERVER
      || this.selectedCert.typeCertificate === CertificateType.CLOUD_CA) && this.roleApprover != '2') {
      if (this.checkCertNumber) {
        if (this.selectedCert.taxCode.length > 0
          && (this.selectedCert.taxCode.toUpperCase() === this.validateSignNextStep.certificateNo.toUpperCase() ||
            (this.validateSignNextStep.representDocumentNumber && this.selectedCert.taxCode.toUpperCase() === this.validateSignNextStep.representDocumentNumber.toUpperCase()) ||
            (this.validateSignNextStep.taxCode && this.selectedCert.taxCode.toUpperCase() === this.validateSignNextStep.taxCode.toUpperCase()))) {
        } else {
          this.toastr.error(this.message.getMessage('messages.digital_certificate_validate_taxCode'));
          return false;
        }
      }

      // check name
      if (this.checkName) {
        const enterpriseName = localStorage.getItem('enterpriseNameProcessing');
        if (enterpriseName && (this.selectedCert.issuedTo.toUpperCase() !== enterpriseName.toUpperCase())) {
          this.toastr.error(this.message.getMessage('messages.digital_certificate_validate_name'));
          return false;
        }
      }
    }

    // check OTP
    if (this.selectedCert.typeCertificate === 3) {
      if (this.checkOtp) {
        const enterprisePhone = this.digitalCertificateService.formatPhoneNumber(localStorage.getItem('enterprisePhoneProcessing'));
        if (enterprisePhone && (this.selectedCert.phoneNumber !== enterprisePhone)) {
          const message = this.commonService.format(this.message.getMessage('messages.digital_certificate_validate_phone'), enterprisePhone);
          this.toastr.error(message);
          return false;
        }
      }
    }
    if (this.selectedCert && (this.selectedCert.issuedTo || this.selectedCert.certificateName)) {
      const issueTo = this.selectedCert.issuedTo || this.selectedCert.certificateName
      this.signConfig.enterpriseName.value = issueTo;
    } else {
      this.signConfig.enterpriseName.value = this.enterpriseName;
    }
    this.signConfig.email.value = this.selectedCert.email;

    let isNextEkyc = false;
    if (this.current === 0) {
      setTimeout(() => {
        this.setFontSize(imageConfigViewScaleId);
        this.setFontSize(imageConfigRenderId);
      }, 100);
      let typeSupportEKYC = this.selectedCert.typeCertificate === this.signMethod.SIGN_OTP
        || this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT;
      let isSignEkyc = this.selectedCert.typeCertificate === this.signMethod.SIGN_EKYC
        || this.selectedCert.typeCertificate === this.signMethod.SIGN_EKYC_ADVANCED
      if (typeSupportEKYC) {
        if (this.supportEkyc && +this.enterpriseInfo.customerType === EnterpriseTypes.PERSONAL) {
          if (+this.enterpriseInfo.certificateId === CertificateTypeID.CCCD
            || +this.enterpriseInfo.certificateId === CertificateTypeID.CMTND
            || +this.enterpriseInfo.certificateId === CertificateTypeID.HO_CHIEU) {
            this.isShowEKYC = true;
            isNextEkyc = await this.getQuantityEkycBeforeNext().toPromise().then()
          } else this.isShowEKYC = false;
        } else this.isShowEKYC = false;
      } else {
        if (isSignEkyc) {
          if (+this.enterpriseInfo.customerType === EnterpriseTypes.PERSONAL) {
            if (+this.enterpriseInfo.certificateId === CertificateTypeID.CCCD
              || +this.enterpriseInfo.certificateId === CertificateTypeID.CMTND
              || +this.enterpriseInfo.certificateId === CertificateTypeID.HO_CHIEU) {
              this.isShowEKYC = true;
              isNextEkyc = await this.getQuantityEkycBeforeNext().toPromise().then()
            } else this.isShowEKYC = false;
          } else this.isShowEKYC = false;
        } else this.isShowEKYC = false;
      }

      if (this.selectedCert.typeCertificate === this.signMethod.SIGN_USB_TOKEN) {
        // check connect plugins
        this.blockUI.start('');
        await checkPlugin(this);
      }
    }

    if (this.current === 0 && this.isShowEKYC && !isNextEkyc) {
      this.toastr.error(this.message.getMessage('digital_certificate_management.quantity_ekyc_not_enough'))
      return
    }

    if (this.current === 0 && this.isShowEKYC && isNextEkyc) {
      if (this.ekyc.errors.length > 0) {
        this.toastr.error(this.message.getMessage('kyc.camera_errors'));
        return
      }
    }
    if (this.current === 1) {
      let isShowDefaultTab = this.selectedCert.typeCertificate !== this.signMethod.SIGN_NO_CERT && this.selectedCert.imageUrl;
      const indexSystemTab = isShowDefaultTab ? 1 : 0;
      if (this.indexSelect == indexSystemTab) {
        this.systemImageSign = true;
      }
      // prepare data before go step 2
      if (this.systemImageSign) {
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
        await this.imageSignConfig.renderImage();
      } else if (this.isSelectDrawImage) {
        this.canvasComponent.onSaveCanvas();
      } else {
        if (this.fileUpload) {
          this.handlePreviewFromFileUpload(this.fileUpload, null);
        }
      }

    }
    if (!this.isShowImage) {
      this.checkTimestampMoney();
      return;
    }
    this.current += 1;
    if (this.current === 1) {
      if (this.selectedCert !== null) {
        this.handleSelectedCert();
      }
    }
    // sau khi chọn ảnh, đến trang chọn vị trí
    if (this.current === 2) {
      if (this.document && this.document.mainContractAttachments) {
        setTimeout(() => {
          const tabs = document.getElementsByClassName('tab');
          if (tabs) {
            Array.from({length: tabs.length}, (v, i) => i).forEach(index => {
              const tab = tabs.item(index) as HTMLElement;
              tab.style.width = 100 / this.document.mainContractAttachments.length + '%';
            })
          }
        }, 100);
        this.viewDocumentsUpload('');
      }
      this.isVisible = true;
      // hiển thị thông báo người dùng chọn vị trí
      this.checkSignManual();
    }
    // this.changeContent();
  }

  handlePreviewFromFileUpload(fileUpload: File, isDefaultCertificate: boolean | null) {
    this.commonService.getBase64(fileUpload)
      // tslint:disable-next-line:no-shadowed-variable
      .then((imageUrlPreviewBlod) => {
        this.imageUrlPreview = imageUrlPreviewBlod;
        this.selectedImageUrl = imageUrlPreviewBlod;
        if (isDefaultCertificate) {
          const img = new Image();
          img.src = this.imageUrlPreview;
          img.onload = () => {
            this.widthImageRender = img.width;
            this.heightImageRender = img.height;
          }
        }
      });
  }

  handleSelectedCert() {
    if (this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT) {
      this.isDisableNextButton = true;
    }
    if (this.selectedCert.imageUrl) {
      // @ts-ignore
      const abortCtrl = new AbortController();
      this.activeAbortCtrl = abortCtrl;
      const generationId = this.activeTabGenerationId;
      fetch(this.selectedCert.imageUrl, { signal: abortCtrl.signal })
        .then(r => r.blob())
        .then(blobFile => {
          if (generationId !== this.activeTabGenerationId) return;
          if (abortCtrl.signal.aborted) return;
          this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
          this.selectedImage = this.fileUpload;
        });

      const img = new Image();
      img.src = this.selectedCert.imageUrl;
      img.onload = () => {
        // Get  width
        this.leftPosition = (this.widthRectangle - img.width * this.heightRectangle / img.height) / 2;
        // tslint:disable-next-line:max-line-length
        // contentNode = `<img src="${this.selectedCert.imageUrl}" style="height: 100%; position: relative; left: ${leftPosition}px;"/>`;
      };
    }
  }

  done(): void {
  }

  onSelectDrawSign() {
    // this.disableBtnDeleteCanvas = true;
    // this.commonService.configCanvas(this.canvas.nativeElement, this.cx, this.canvasWidth, this.canvasHeight);
    this.canvasService.setIsSelectSignDraw(true);
  }

  async ngOnInit() {
    this.subscriptions.add(
      this.signDocumentService.openSigningDialog.subscribe(rs => {
        this.openSigningDialog = rs
      })
    );

    this.contractId = this.activeRoute.snapshot.paramMap.get('id');
    this.subscribeValue();
    this.getEnterprise();
    this.viewDocumentsUpload(this.contractId);
    const userId = localStorage.getItem('userId');
    if (userId) {
      this.documentService.getListEnterpriseUserSignBydocumentIdService(this.contractId).subscribe(res => {
        const userSign = res.data.userSign;
        const approverFilter = userSign.find(rs => rs.userId === userId);
        // console.log('approverFilter', approverFilter);
        if (approverFilter) {
          this.roleApprover = approverFilter.role;
          this.isSignDigitalCertificate = approverFilter.isSignDigitalCertificate;
          this.loadConfigAndCertificates(approverFilter.role);
          if (approverFilter.signConfig && JSON.parse(approverFilter.signConfig)) {
            this.canMoveAndResize = approverFilter.signConfig ? JSON.parse(approverFilter.signConfig).resize : false;
            this.isShowImage = approverFilter.signConfig ? this.setDataSignConfig(JSON.parse(approverFilter.signConfig)).showImage : {
              resize: false,
              showImage: approverFilter.isSignDigitalCertificate ? true : (approverFilter.role + '' == '1' ? true : false)
            }.showImage;
            console.log(this.isShowImage);
          }
        } else {
          this.loadConfigAndCertificates('');
        }
      });
    } else {
      this.loadConfigAndCertificates('');
    }

    // kiểm tra xem có quyền quản lý tt doanh nghiệp hay không
    if (this.permissions.includes(1)) {
      this.isHasPermissionAddCert = true;
    }
    this.commonService.getCurrentLanguage().subscribe(lang => {
      if (lang !== this.language) {
        location.reload();
      }
    });
    // this.getDocumentById(this.contractId);
    this.getUserConfig();
  }

  ngAfterViewInit() {
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumnsSimCA();
          this.getDisplayedColumnsOther();
          this.getDisplayedColumnsCloudCa();
          switch (this.mediaBreakpoint) {
            case SCREEN_SIZE.XS:
              this.canvasWidth = 320;
              this.canvasHeight = Math.round(320 * (136 / 300));
              break;
            case SCREEN_SIZE.SM:
              this.canvasWidth = 345;
              this.canvasHeight = Math.round(345 * (136 / 300));
              break;
            case SCREEN_SIZE.MD:
              this.canvasWidth = 450;
              break;
            case SCREEN_SIZE.XL:
              this.canvasWidth = 470;
              break;
            default:
              this.canvasWidth = 660;
              break;
          }
        }
      }
    );

    this.subcribeViewLandscape = this.responsiveService.getView().subscribe(isLandscape => {
      this.isViewLandscape = isLandscape;
    });
    this.getDocumentById(this.contractId);
  }

  getDisplayedColumnsSimCA() {
    switch (this.mediaBreakpoint) {
      case SCREEN_SIZE.XS:
        this.columnsToDisplaySimCA = this.columnDefinitionsSimCA.filter(cd => cd.showXS).map(cd => cd.def);
        break;
      case SCREEN_SIZE.SM:
        this.columnsToDisplaySimCA = this.columnDefinitionsSimCA.filter(cd => cd.showSM).map(cd => cd.def);
        break;
      case SCREEN_SIZE.MD:
        this.columnsToDisplaySimCA = this.columnDefinitionsSimCA.filter(cd => cd.showMD).map(cd => cd.def);
        break;
      case SCREEN_SIZE.LG:
        this.columnsToDisplaySimCA = this.columnDefinitionsSimCA.filter(cd => cd.showLG).map(cd => cd.def);
        break;
      case SCREEN_SIZE.XL:
        this.columnsToDisplaySimCA = this.columnDefinitionsSimCA.filter(cd => cd.showXL).map(cd => cd.def);
        break;
      default:
        this.columnsToDisplaySimCA = this.columnDefinitionsSimCA.map(cd => cd.def);
        break;
    }
  }

  getDisplayedColumnsOther() {
    switch (this.mediaBreakpoint) {
      case SCREEN_SIZE.XS:
        this.columnsToDisplayOther = this.columnDefinitionsOther.filter(cd => cd.showXS).map(cd => cd.def);
        break;
      case SCREEN_SIZE.SM:
        this.columnsToDisplayOther = this.columnDefinitionsOther.filter(cd => cd.showSM).map(cd => cd.def);
        break;
      case SCREEN_SIZE.MD:
        this.columnsToDisplayOther = this.columnDefinitionsOther.filter(cd => cd.showMD).map(cd => cd.def);
        break;
      case SCREEN_SIZE.LG:
        this.columnsToDisplayOther = this.columnDefinitionsOther.filter(cd => cd.showLG).map(cd => cd.def);
        break;
      case SCREEN_SIZE.XL:
        this.columnsToDisplayOther = this.columnDefinitionsOther.filter(cd => cd.showXL).map(cd => cd.def);
        break;
      default:
        this.columnsToDisplayOther = this.columnDefinitionsOther.map(cd => cd.def);
        break;
    }
  }

  getDisplayedColumnsCloudCa() {
    switch (this.mediaBreakpoint) {
      case SCREEN_SIZE.XS:
        this.columnsToDisplayCloudCa = this.columnDefinitionsCloudCa.filter(cd => cd.showXS).map(cd => cd.def);
        break;
      case SCREEN_SIZE.SM:
        this.columnsToDisplayCloudCa = this.columnDefinitionsCloudCa.filter(cd => cd.showSM).map(cd => cd.def);
        break;
      case SCREEN_SIZE.MD:
        this.columnsToDisplayCloudCa = this.columnDefinitionsCloudCa.filter(cd => cd.showMD).map(cd => cd.def);
        break;
      case SCREEN_SIZE.LG:
        this.columnsToDisplayCloudCa = this.columnDefinitionsCloudCa.filter(cd => cd.showLG).map(cd => cd.def);
        break;
      case SCREEN_SIZE.XL:
        this.columnsToDisplayCloudCa = this.columnDefinitionsCloudCa.filter(cd => cd.showXL).map(cd => cd.def);
        break;
      default:
        this.columnsToDisplayCloudCa = this.columnDefinitionsCloudCa.map(cd => cd.def);
        break;
    }
  }

  getButtonsMobile() {
    if (this.buttonsDefinitions.length > 0 && this.deviceService.isMobile) {
      // Kiểm tra các điều kiện của nút.
      if (this.current > 0) {
        this.buttonsDefinitions[1].hide = false;
      }

      if (this.current < 2) {
        this.buttonsDefinitions[2].hide = false;
      }

      if (this.current === 2) {
        this.buttonsDefinitions[3].hide = false;
        this.buttonsDefinitions[4].hide = false;
        this.buttonsDefinitions[5].hide = false;
      }

      // Lọc ra các button sẽ hiển thị.
      this.slidesButtons = this.buttonsDefinitions.filter(x => x.hide == false);

      // sắp xếp theo giá trị sortOrder đã set.
      this.slidesButtons = this.slidesButtons.sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
      });
    }
  }


  processRouteAndBreadcrumbs(): void {
    this.activeRoute
      .queryParams
      .subscribe(params => {
        this.signPage = params.signPage || 1;
        this.page = params.page || 0;
        this.pageSize = params.pageSize || 0;
        this.routeLink = params.routeLink || null;
        this.enterprise = params.enterprise || null;
        this.documentTypeSearch = params.documentType || null;
        this.nameOrCode = params.nameOrCode || null;
        this.status = Common.DOCUMENT_STATUS.indexOf(params.status) === -1 ? null : params.status;
        this.serviceType = params.serviceType || null;
        this.taxCode = params.taxCode || null;
        this.createdUser = params.createdUser || null;
        this.createdTimeFrom = params.createdTimeFrom || null;
        this.createdTimeTo = params.createdTimeTo || null;
        this.finishDateFrom = params.finishDateFrom || null;
        this.finishDateTo = params.finishDateTo || null;
        this.sortColumn = params.sortColumn || null;
        this.sortDirection = params.sortDirection || null;
        this.goFrom = params.goFrom || null;
        this.messageSign = params.message ? params.message : '';
        this.customerName = params.customerName || '';

        this.documentService.getSignDataValidate().subscribe((validate: any) => {
          this.validateSignNextStep.certificateNo = validate.certificateNo;
          this.validateSignNextStep.representDocumentNumber = validate.representDocumentNumber;
          this.validateSignNextStep.taxCode = validate.taxCodeValidate;
        });

        // tslint:disable-next-line:radix

        let bread;
        if (this.goFrom === 'receive') {
          bread = {label: 'breadcrumbs.document_search_receive', url: 'search-document-receive', params: []};
          this.routeLink = this.DEFAULT_RECEIVER_ROUTER_ON_BACK_LINK;
        } else if (this.goFrom === 'waitSign') {
          bread = {label: 'breadcrumbs.document_search_sign', url: 'search-document-sign', params: []};
          this.routeLink = this.SIGN_WAIT_ROUTER_ON_BACK_LINK;
        } else if (this.goFrom === 'waitSignMoha') {
          bread = {label: 'breadcrumbs.approved_contract_moha', url: 'approved-contract-moha', params: []};
          this.routeLink = this.SIGN_WAIT_ROUTER_ON_BACK_LINK_MOHA;
        }else if (this.goFrom === 'waitApprove') {
          bread = {label: 'breadcrumbs.document_search_approve', url: 'search-approval-waiting-document', params: []};
          this.routeLink = this.APPOVAL_WAIT_ROUTER_ON_BACK_LINK;
        } else if (this.goFrom === 'waitInitial') {
          bread = {label: 'breadcrumbs.document_search_initial', url: 'search-initial-waiting-document', params: []};
          this.routeLink = this.INITIAL_WAIT_ROUTER_ON_BACK_LINK;
        } else if (this.goFrom === 'mine') {
          bread = {label: 'breadcrumbs.document_search_mine', url: 'search-my-created-document', params: []};
          this.routeLink = this.MY_DOCUMENT_ROUTER_ON_BACK_LINK;
        } else if (this.goFrom === 'waitSign') {
          bread = {label: 'breadcrumbs.document_search_mine', url: 'document-approved-contract', params: []};
          this.routeLink = this.SIGN_WAIT_ROUTER_ON_BACK_LINK_APPROVED;
        } else {
          bread = {label: 'breadcrumbs.document_search', url: 'search-document', params: []};
          this.routeLink = this.DEFAULT_ROUTER_ON_BACK_LINK;
        }

        if (this.isSignDigitalCertificate) {
          this.breadcrumbsService.store([
            {label: 'breadcrumbs.home', url: 'analysis-report', params: []},
            {label: 'breadcrumbs.document_breadcrumbs', url: '', params: []},
            bread,
            {label: 'breadcrumbs.document_approve', url: 'sign-document/', params: []},
          ]);
        } else {
          this.breadcrumbsService.store([
            {label: 'breadcrumbs.home', url: 'analysis-report', params: []},
            {label: 'breadcrumbs.document_breadcrumbs', url: '', params: []},
            bread,
            {label: 'breadcrumbs.document_sign', url: 'sign-document/', params: []},
          ]);
        }
      });
  }

  ngOnDestroy(): void {
    if (this.activeAbortCtrl) {
      this.activeAbortCtrl.abort();
      this.activeAbortCtrl = null;
    }
    this.destroy$.next();
    this.destroy$.complete();
    this.canvasService.setCanvasImageUrl('')
    this.canvasService.setCanvasImage(null)
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
    this.subcribeViewLandscape.unsubscribe();
    this.subcribePreviewImageUrl.unsubscribe();
    this.subcribePreviewImage.unsubscribe();
    this.isSelectDrawImage = false;
    this.isDisableNextButton = false;
    this.fileUpload = null;
    this.systemImageSign = false;
    this.imageUrlPreview = null;
    this.selectedImage = null
    this.document = null;
    this.pdfSrc = null;
  }

  subscribeValue() {
    this.documentService.contractInfo.subscribe(contract => {
      if (!contract) {
        const contractId = this.activeRoute.snapshot.paramMap.get('id');
        this.getDocumentById(contractId);
      } else {
        this.document = contract;
      }
    });

    this.documentService.contractFilesInfo.subscribe(info => {
      this.listPdfSrc = info;
    });

    this.subcribePreviewImageUrl = this.canvasService.canvasImageUrl.subscribe(url => {
      this.imageUrlPreview = url;
      const img = new Image();
      img.src = this.imageUrlPreview;
      img.onload = () => {
        this.widthImageRender = img.width;
        this.heightImageRender = img.height;
      }
    });

    this.subcribePreviewImage = this.canvasService.canvasImage.subscribe(fileImage => {
      this.fileUpload = fileImage;
    });

    this.canvasService.isDisableBtnDeleteCanvas.subscribe(disable => {
      let isShowDefaultTab = this.selectedCert.typeCertificate !== this.signMethod.SIGN_NO_CERT && this.selectedCert.imageUrl;
      const indexUploadTab = isShowDefaultTab ? 2 : 1;
      const indexDrawTab = isShowDefaultTab ? 3 : 2;
      this.disableBtnDeleteCanvas = disable;
      if (disable && this.current === 1 && this.indexSelect === indexUploadTab
        && (this.selectedCert.typeCertificate === CertificateType.EKYC || this.selectedCert.typeCertificate === CertificateType.EKYC_ADVANCED)) {
        this.isDisableNextButton = true;
      } else if (disable && this.current === 1 && this.indexSelect === indexDrawTab) {
        this.isDisableNextButton = true;
      } else if (disable && this.current === 1 && this.indexSelect === indexUploadTab && this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT) {
        this.isDisableNextButton = true;
      } else {
        this.isDisableNextButton = false;
      }
    });
    this.notificationService.subscribeErrorService();

    this.notificationService.getErrorCode().subscribe(errorCode => {
      if (errorCode === ErrorCode.NoAccessToContracts) {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
        this.isCheckAccessToContract = false;
      } else {
        this.isCheckAccessToContract = true;
      }

      if (errorCode === ErrorCode.NotPermissionWithContract) {
        this.backToPrePage();
      }
    });

    this.processRouteAndBreadcrumbs();
    // lấy sign position
    this.documentService.getSignPosition().subscribe(position => {
      if (this.signPosition && this.signPosition.length > 0) {
        this.checkSignManual();
        // this.imageData = position.map((item) => {
        //   return {
        //     positionX: item.x,
        //     positionY: item.y,
        //     pageNumber: item.pageNumber,
        //     signType: item.signType,
        //     widthRectangle: item.width,
        //     heightRectangle: item.height,
        //     zoom: 1,
        //     fileId: item.fileId,
        //     signPositionId: item.id
        //   };
        // });

        //         this.imageData = {
        //   stampPositionLeft: mousedownEvent.clientX - signatureWidth / 2 - left,
        //   stampPositionTop: mousedownEvent.clientY - heightRectangle / 2 - top,
        //   // positionX: 100 * (mousedownEvent.clientX - signatureWidth / 2 - left) / zoomLevel,
        //   positionX: 100 * wrapperLeft / zoomLevel,
        //   // positionY: 100 * (mousedownEvent.clientY - heightRectangle / 2 - top) / zoomLevel,
        //   positionY: 100 * wrapperTop / zoomLevel,
        //   pageIndex,
        //   zoom: this.zoomLevel / 100,
        //   pdfSrc: this.pdfSrc,
        //   pageNumber,
        //   type: SignDocumentComponent.SIGN_SINGLE,
        //   widthRectangle: this.widthRectangle,
        //   heightRectangle: this.heightRectangle
        // };
      } else {
        this.isAllowSelectSignPosition = true;
        // this.signPosition = [];
      }
    });

    this.documentService.cancelFlow.subscribe(status => {
      if (status != null || status != undefined) {
        this.isCancelSign = status
      }
    })
  }

  getDocumentById(id: string) {
    if (id) {
      this.documentService.getDocumentById(id).subscribe(rs => {
        if (!rs || !rs.data) {
          if (rs && rs.message) {
            this.toastr.error(rs.message);
          }
          return;
        }
        this.document = rs.data.contractDTO;
        this.scopeType = this.document.scopeType || 0;
        this.documentService.setContractInfo(rs.data.contractDTO);
        this.signPosition = rs.data.contractSignEntityList;
        // console.log('hiepnh1', this.signPosition);
        this.documentService.setSignPosition(this.signPosition);
        if (this.signPosition && this.signPosition.length > 0) {
          this.imageData = rs.data.contractSignEntityList.map((item) => {
            const image = {
              positionX: item.x,
              positionY: item.y,
              pageNumber: item.pageNumber,
              signType: item.signType,
              widthRectangle: item.width,
              heightRectangle: item.height,
              id: item.id,
              zoom: 1,
              fileId: item.fileId,
              signPositionId: item.id,
              contractSignId: undefined
            };

            // Trường hợp tài khoản không chứng thực, kí gửi lên contractSignId
            if (this.isNotAttestedUser) image.contractSignId = item.id;

            return image;
          });
        } else {
          this.isAllowSelectSignPosition = true;
          this.signPosition = []
        }
        // view file pdf
        if (!this.listPdfSrc) {
          this.viewContractFile();
        }
      });
    }
  }

  viewContractFile() {
    if (!this.listPdfSrc) {
      this.listPdfSrc = {}
    }
    const firstFile = this.document.mainContractAttachments[0];
    this.viewDocumentUpload(this.document.id, firstFile.path, firstFile.fileSize).then(res => {
      if (res) {
        // xong thằng đầu tiên
        this.pdfSrc = res;
        this.listPdfSrc[firstFile.path] = res;
        // xử lý các file tiếp theo
        for (const item of this.document.mainContractAttachments) {
          if (item.path != firstFile.path) {
            this.viewDocumentUpload(this.document.id, item.path, item.fileSize);
          }
        }
      }
    }).catch(e => {
      this.toastr.error("error")
    });
  }

  openDialogAddCert() {
    this.dialogRef = this.dialog.open(AddDigitalCertificateComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : this.mediaBreakpoint === SCREEN_SIZE.MD || this.mediaBreakpoint === SCREEN_SIZE.LG ? '80%' : '80%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : this.mediaBreakpoint === SCREEN_SIZE.MD || this.mediaBreakpoint === SCREEN_SIZE.LG ? '90vw' : '80vw',
      panelClass: 'scontract-overlay-dialog',
      data: {
        isCreateMysign : true
      }
    });
    this.dialogRef.afterClosed().subscribe(result => {
      if (this.dialogRef.componentInstance.success) {
        // this.onFilterDataAfterClose();
        // this.getCertificates().subscribe(data => {
        //   console.log(data)
        // });
        this.getCertificatesPreOne();
        this.selectFirstCertificate();
      }
    });
  }

  getCertificates() {
    //     this.digitalCertificateService.getCertificates(this.enterpriseId).subscribe(rs => {
    this.digitalCertificateService.getCertificates(this.enterpriseId).subscribe(rs => {
      this.imageCertificates = [];
      this.certificates = rs.data;
      this.isCertificateDefault = false;
      let indexCer = 0;
      let countList = -1;
      let indexList = 0;
      if (this.certificates.length > 0) {
        for (const cerType of this.certificates) {
          countList++;
          cerType.listCert = cerType.listCert.map((item, index) => {
            if (item.defaultCertificate && !(item.typeCertificate === 0 && !this.isHsmPermission)) {
              this.isCertificateDefault = true;
              indexCer = index;
              indexList = countList;
            }
            const {imagePath} = item;
            if (imagePath) {
              const imageDataBlob = this.commonService.b64toBlob(imagePath);
              const blobUrl = URL.createObjectURL(imageDataBlob);
              return {
                ...item,
                imageUrl: blobUrl
              };
            } else {
              return {
                ...item,
                imageUrl: ''
              };
            }
          });
        }
        this.imageCertificates = [
          ...this.imageCertificates,
          ...this.certificates.filter(certificate => {
            if (certificate.type === this.signMethod.SIGN_SERVER && !this.isHsmPermission) {
              return false;
            }
            if (!this.allowOtp) {
              return Number(certificate.type) !== this.signMethod.SIGN_OTP
            } else return certificate
          }),
        ];

        // Select first certificate
        // this.typeCertificate = this.imageCertificates[0].type;
        // this.selectedCert = this.imageCertificates[0].listCert[0];
      }

      // nếu là người dùng cá nhân mới cho phép ký bằng ảnh
      // if (this.userType === 5 && this.allowImage) {
      //   let imageType = this.imageCertificates.find(cer => Number(cer.type) === this.signMethod.SIGN_NO_CERT);
      //   if (!imageType) {
      //     this.imageCertificates = [
      //       ...this.imageCertificates,
      //       {
      //         type: 6,
      //         listCert: [
      //           { typeCertificate: 6 }
      //         ]
      //       }
      //     ];
      //   }
      // }

      if (this.imageCertificates.length > 0) {
        // Select first certificate
        this.typeCertificate = this.imageCertificates[0].type;
        if (this.isCertificateDefault) {
          this.selectedCert = this.imageCertificates[indexList].listCert[indexCer];
        } else {
          this.selectedCert = this.imageCertificates[0].listCert[0];
        }

        this.isCheckedFirstCertificate();
        this.isDisableNextButton = false;
      } else {
        this.isDisableNextButton = true;
      }
      this.selectedIndex = 0;
      if (this.isCertificateDefault) {
        // this.countAllApiBeforeCertificateDefault += 1;
        this.sertificateDefaultOnj = this.imageCertificates[indexList].listCert[indexCer];
        this.signFlowDocumentWithCerDefault();
      }
    });
  }

  private isCheckedFirstCertificate() {
    if ((this.selectedCert.typeCertificate == this.signMethod.SIGN_OTP || this.selectedCert.typeCertificate == this.signMethod.SIGN_NO_CERT)
      && (this.isStillQuantityEkyc && this.supportEkyc && !this.isCertificateSupport) || (!this.isStillQuantityEkyc && this.supportEkyc)) {
      this.selectedCert = {
        serialNumber: '',
        phoneNumber: undefined,
        typeCertificate: undefined,
        id: undefined,
        idDetail: undefined,
        imageUrl: null,
        issuedTo: '',
        taxCode: '',
      };
      this.isReloadCamera = true;
    } else if (this.selectedCert.typeCertificate == this.signMethod.SIGN_OTP || this.selectedCert.typeCertificate == this.signMethod.SIGN_NO_CERT) {
      this.isReloadCamera = false;
    }
  }

  private checkCerExisted(cer: any): boolean {
    if (this.imageCertificates.find(item => item.type === cer.type)) {
      return true;
    } else return false;
  }

  async selectFirstCertificate() {
    this.blockUI.start('');
    // await this.getCertificates().toPromise().then();
    this.getEnterprise();
    this.blockUI.stop();
    if (this.imageCertificates.length > 0) {
      let isSelectCertificate = false;
      // if (this.supportEkyc) {
      this.imageCertificates.forEach((certificate, index) => {
        if (isSelectCertificate) return;
        if (certificate.type === this.signMethod.SIGN_NO_CERT
          || certificate.type === this.signMethod.SIGN_OTP) {
          if (this.supportEkyc) {
            if (this.isStillQuantityEkyc) {
              if (this.isCertificateSupport) {
                // setTimeout(() => {
                this.typeCertificate = this.imageCertificates[index].type;
                this.selectedCert = this.imageCertificates[index].listCert[0];
                // console.log(this.selectedCert)
                // console.log(this.imageCertificates)
                // }, 0);
                isSelectCertificate = true;
              }
            }
          } else {
            // setTimeout(() => {
            this.typeCertificate = this.imageCertificates[index].type;
            this.selectedCert = this.imageCertificates[index].listCert[0];
            // console.log(this.selectedCert)
            // console.log(this.imageCertificates)
            isSelectCertificate = true;
            // }, 0);
          }
        } else {
          setTimeout(() => {
            this.typeCertificate = this.imageCertificates[index].type;
            this.selectedCert = this.imageCertificates[index].listCert[0];
          }, 0);
          isSelectCertificate = true;
        }
        // } else if (certificate.type === this.signMethod.SIGN_EKYC || certificate.type === this.signMethod.SIGN_EKYC_ADVANCED) {
        //     if (this.isQuantityEkyc && this.isCertificateSupport && certificate.type === this.signMethod.SIGN_EKYC) {
        //       setTimeout(() => {
        //         this.typeCertificate = this.imageCertificates[index].type;
        //         this.selectedCert = this.imageCertificates[index].listCert[0];
        //       }, 0);
        //       isSelectCertificate = true;
        //     }
        //     if (this.isQuantityAdvancedEkyc && this.isCertificateSupport && certificate.type === this.signMethod.SIGN_EKYC_ADVANCED) {
        //       // setTimeout(() => {
        //         this.typeCertificate = this.imageCertificates[index].type;
        //         this.selectedCert = this.imageCertificates[index].listCert[0];
        //       // }, 0);
        //       isSelectCertificate = true;
        //     }
        // } else {
        //   setTimeout(() => {
        //     this.typeCertificate = this.imageCertificates[index].type;
        //     this.selectedCert = this.imageCertificates[index].listCert[0];
        //   }, 0);
        //   isSelectCertificate = true;
        // }
      })
      this.isDisableNextButton = false;
    } else {
      this.isDisableNextButton = true;
    }
  }

  dummyRequest = ({file, onSuccess, onError}) => {
    this.fileUpload = file;
    this.isDisableNextButton = false;
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  }

  viewDocumentUpload(contractId, pdfFilePath, size?) {
    return new Promise((resolve, reject) => {
      const data: ViewDocumentReferenceDto = {
        mainContractId: contractId,
        referenceContractId: '',
        pdfFilePath: pdfFilePath
      };
      if (!this.env.pdfViewFullDownload && size && size > 10485760) {
        const queryString = Object.entries(data)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
          .join('&');
        // const res = await this.commonService.getViewPdfForDocumentByFilePath(data).toPromise();
        const pdfSrc = `${this.BASE_URL}?${queryString}`;
        this.listPdfSrc[pdfFilePath] = pdfSrc;
        this.document.mainContractAttachments.forEach(item => {
          if (item.path == pdfFilePath) {
            item.loading = false;
          }
        });
      } else {
        try {
          this.commonService.getViewPdfForDocumentByFilePath(data).subscribe(
            res => {
              this.blobToSrc(res).then(res => {
                this.listPdfSrc[pdfFilePath] = res;
                resolve(res);
              }).catch(e => {
                reject(e);
              });
            }
          );
        } catch (e) {
          reject(e);
        }
      }

    });
  }

  handleChange(info: { file: NzUploadFile }): void {
    // this.isFormChanging = true;
    switch (info.file.status) {
      case 'uploading':
        this.loading = true;
        break;
      case 'done':
        // Get this url from response in real world.
        // tslint:disable-next-line:no-non-null-assertion
        this.commonService.getBase64Avatar(info.file!.originFileObj!, (imgUrl: string) => {
          this.loading = false;
          // tslint:disable-next-line:radix
          const img = new Image();
          // Set the src attribute to your URL
          img.src = imgUrl;
          this.imagePreviewWidth = img.width;
          this.imagePreviewHeight = img.height;
          // When the image is loaded, read the available properties
          this.avatarUrl = imgUrl;
          this.imageUrlPreview = imgUrl;
        });
        break;
      case 'error':
        this.toastr.error('Network error');
        this.loading = false;
        break;
    }
  }

  textLayerRendered(ele) {
    const element = ele.source.textLayerDiv;
    const pageIndex = ele.source.pageNumber;
    element.addEventListener('mouseenter', () => {
      this.pageIndex = pageIndex;
    });
    // lấy các chữ ở trang pageNumber
    let signPosition;
    const fileId = this.document.mainContractAttachments[this.activeFile].id;
    const id = this.decodeId(fileId);
    const imageId = this.commonService.generateUUID();
    if (this.signPosition && this.signPosition.length > 0) {
      signPosition = this.signPosition.filter((item) => {
        return item.pageNumber === pageIndex && id === item.fileId;
      });
    }
    // console.log('hiepnh ', signPosition);
    // console.log('hiepnh ', this.imageData);
    if (signPosition && signPosition.length > 0) {
      for (const position of signPosition) {
        const x = position.x;
        const y = position.y;
        const _width = position.width;
        const _height = position.height;
        const signType = position.signType;
        const id = position.id;
        const htmlNode = this.getStampWrapper(x, y, _width, _height, signType, id, element, parseInt(position.page));
        const hasImage = this.signPosition.some(e => e.signType === SignPositionTypes.IMAGE);
        if (signType === SignPositionTypes.DIGITAL && hasImage) {
          console.log('not show digital');
        } else {
          element.appendChild(htmlNode);
        }
      }
      if (!this.isGotoSignpage) {
        const firstPosition = signPosition[0];
        const firstPage = firstPosition.pageNumber;
        this.signPage = firstPosition.pageNumber;
        this.gotoSignPageNumber(firstPage);
        this.isGotoSignpage = true;
      }
      const fileCustomerSign = this.signPosition.find(sign => sign.fileId === id && sign.isNew);
      this.isAllowSelectSignPosition = !!fileCustomerSign;
      this.isSelectPosition = false;
    }
    if (this.isAllowSelectSignPosition) {
      //
      element.addEventListener('mouseleave', (mouseoverEvent) => {
        if (this.isSelectPosition) {
          const nodeOther = document.getElementById('show-frames-notification');
          if (nodeOther) {
            nodeOther.remove();
          }
        }
      });
      element.addEventListener('wheel', (wheelEvent) => {
        if (this.isSelectPosition) {
          const node = element.querySelector('#show-frames-notification');
          const nodeOther = document.getElementById('show-frames-notification');
          if (!node && nodeOther) {
            nodeOther.remove();
          }
          const boundingClient = element.getBoundingClientRect();
          const {top, left} = boundingClient;
          const signatureWidth = this.widthRectangle * this.zoomLevel / 100;
          const heightRectangle = this.heightRectangle * this.zoomLevel / 100;
          if (!node) {
            const stampNode = document.createElement('div');
            stampNode.innerHTML = this.genStampContent();
            this.stampWrapper = stampNode;
            stampNode.style.position = 'absolute';
            stampNode.setAttribute('id', 'show-frames-notification');
            stampNode.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
            stampNode.style.top = `${(wheelEvent.clientY - heightRectangle / 2 - top)}px`;
            stampNode.style.width = `${signatureWidth}px`;
            stampNode.style.height = `${heightRectangle}px`;
            stampNode.style.zIndex = '1';
            stampNode.style.background = 'rgb(0,0,0,0.2)';
            stampNode.style.border = '1px solid';
            stampNode.style.lineHeight = '1.9';
            stampNode.style.color = '#00f';
            stampNode.style.fontFamily = 'Roboto, sans-serif';
            stampNode.style.padding = `${10 * this.zoomLevel / 100}px`;
            stampNode.style.fontSize = `${16 * this.zoomLevel / 100}px`;
            if (this.fileUpload) {
              stampNode.style.display = 'flex';
              stampNode.style.alignItems = 'center';
              stampNode.style.justifyContent = 'center';
            }

            element.appendChild(stampNode);
          } else {
            node.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
            node.style.top = `${(wheelEvent.clientY - heightRectangle / 2 - top)}px`;
          }
        }
      });
      element.addEventListener('mousedown', (mousedownEvent) => {
        if (this.isSelectPosition) {
          this.isSelectPosition = false;
          // xoá dòng chọn vị trí
          const framesNotification = document.getElementById('show-frames-notification');
          if (framesNotification) {
            framesNotification.remove();
          }
          const offsetParent = element.offsetParent.dataset;
          const {pageNumber} = offsetParent;
          const boundingClient = element.getBoundingClientRect();
          const {top, left} = boundingClient;
          const signatureWidth = this.widthRectangle * this.zoomLevel / 100;
          const heightRectangle = this.heightRectangle * this.zoomLevel / 100;
          const signZoom = this.zoomLevel / 100;

          const widthHeightRatio = signatureWidth / heightRectangle;
          const wrapperLeft = mousedownEvent.clientX - signatureWidth / 2 - left;
          const wrapperTop = mousedownEvent.clientY - heightRectangle / 2 - top;
          this.stampWrapper.style.left = `${wrapperLeft}px`;
          this.stampWrapper.style.top = `${wrapperTop}px`;
          this.stampWrapper.style.width = `${signatureWidth}px`;
          this.stampWrapper.style.height = `${heightRectangle}px`;
          this.stampWrapper.style.background = 'rgb(0,0,0,0.2)';
          this.stampWrapper.style.zIndex = '1';
          this.stampWrapper.style.border = '1px solid #999999';
          this.stampWrapper.style.lineHeight = '1.9';
          this.stampWrapper.style.color = '#00f';
          this.stampWrapper.style.fontFamily = 'Roboto, sans-serif';
          this.stampWrapper.style.padding = `${10 * this.zoomLevel / 100}px`;
          this.stampWrapper.style.fontSize = `${16 * this.zoomLevel / 100}px`;
          if (this.fileUpload) {
            this.stampWrapper.style.display = 'flex';
            this.stampWrapper.style.alignItems = 'center';
            this.stampWrapper.style.justifyContent = 'center';
          }

          this.stampWrapper.innerHTML = this.genStampContent();
          if (this.canMoveAndResize) {
            const resizer = document.createElement('div');
            resizer.setAttribute('class', 'resize-div-bot-right');
            resizer.style.setProperty('--zoom', signZoom.toString());
            const rerenderSign = () => {
              this.stampWrapper.appendChild(resizer);
              resizer.style.removeProperty('--zoom');
              resizer.style.setProperty('--zoom', (signZoom).toString());
              return;
            };
            this.stampWrapper.appendChild(resizer);
            let startX, startY;
            let baseWidth;
            let baseHeight;
            resizer.addEventListener('mousedown', (e) => {
              e.stopPropagation();
              startX = e.clientX;
              startY = e.clientY;
              // const targetSignId = e.target as Element;
              // signId = targetSignId.parentElement.id.replace('sign-', '');
              baseWidth = this.stampWrapper.offsetWidth;
              baseHeight = this.stampWrapper.offsetHeight;
              document.documentElement.addEventListener('mousemove', doDrag);
              document.documentElement.addEventListener('mouseup', stopDrag);

            });
            const doDrag = (e) => {
              e.stopPropagation();
              const positionData = this.signPosition.find(sign => sign.id === imageId);
              const signatureH = positionData.width * this.zoomLevel / 100;
              const signatureW = positionData.width * this.zoomLevel / 100;
              this.stampWrapper.style.width = (signatureW + e.clientX - startX) + 'px';
              this.stampWrapper.style.height = (signatureH + e.clientY - startY) + 'px';
              const widthHeightRatioDrag = this.stampWrapper.offsetWidth / this.stampWrapper.offsetHeight;
              if (widthHeightRatio !== widthHeightRatioDrag) {
                this.stampWrapper.style.height = (this.stampWrapper.offsetWidth / widthHeightRatio) + 'px';
                this.stampWrapper.style.width = (this.stampWrapper.offsetHeight * widthHeightRatio) + 'px';
              }
              this.stampWrapper.style.maxWidth = (element.offsetWidth - this.stampWrapper.offsetLeft) + 'px';
              this.stampWrapper.style.maxHeight = (element.offsetHeight - this.stampWrapper.offsetTop) + 'px';
              this.stampWrapper.innerHTML =
                this.genStampContentWidthHeight(Number(this.stampWrapper.offsetWidth), Number(this.stampWrapper.offsetHeight), null, true);

              rerenderSign();
            };
            const stopDrag = (e) => {
              e.stopPropagation();
              if (this.stampWrapper.offsetWidth / 2 + wrapperLeft < 0 || this.stampWrapper.offsetHeight / 2 + wrapperTop < 0) {
                this.stampWrapper.style.width = baseWidth + 'px';
                this.stampWrapper.style.height = baseHeight + 'px';
              } else {
                baseWidth = this.stampWrapper.offsetWidth;
                baseHeight = this.stampWrapper.offsetHeight;
              }
              this.stampWrapper.innerHTML =
                this.genStampContentWidthHeight(Number(this.stampWrapper.offsetWidth), Number(this.stampWrapper.offsetHeight), null, true);
              // this.signPosition[0].width = this.stampWrapper.offsetWidth;
              // this.signPosition[0].height = this.stampWrapper.offsetHeight;
              // this.imageData[0].widthRectangle = this.stampWrapper.offsetWidth;
              // this.imageData[0].heightRectangle = this.stampWrapper.offsetHeight;
              this.signPosition = this.signPosition.map(position => {
                if ((position.id === imageId) && position.fileId === id) {
                  position.width = this.stampWrapper.offsetWidth;
                  position.height = this.stampWrapper.offsetHeight;
                }
                return position;
              });
              this.imageData = this.imageData.map(position => {
                if ((position.id === imageId) && position.fileId === id) {
                  position.widthRectangle = this.stampWrapper.offsetWidth;
                  position.heightRectangle = this.stampWrapper.offsetHeight;
                }
                return position;
              });
              rerenderSign();
              document.documentElement.removeEventListener('mousemove', doDrag);
              document.documentElement.removeEventListener('mouseup', stopDrag);
            };
          }
          element.appendChild(this.stampWrapper);

          // xoá dòng thông báo click để chọn vị trí
          document.querySelectorAll('#notify_outside').forEach(item => {
            if (item) {
              item.remove();
            }
          });
          const zoomLevel = this.zoomLevel;
          this.imageData = this.imageData.filter(img => {
            return img.fileId !== fileId;
          });
          this.imageData.push({
            stampPositionLeft: mousedownEvent.clientX - signatureWidth / 2 - left,
            stampPositionTop: mousedownEvent.clientY - heightRectangle / 2 - top,
            // positionX: 100 * (mousedownEvent.clientX - signatureWidth / 2 - left) / zoomLevel,
            positionX: 100 * wrapperLeft / zoomLevel,
            // positionY: 100 * (mousedownEvent.clientY - heightRectangle / 2 - top) / zoomLevel,
            positionY: 100 * wrapperTop / zoomLevel,
            pageIndex,
            zoom: this.zoomLevel / 100,
            pdfSrc: this.pdfSrc,
            pageNumber,
            id: imageId,
            isNew: true,
            signType: SignPositionTypes.COMBINE,
            type: SignDocumentComponent.SIGN_SINGLE,
            widthRectangle: this.widthRectangle,
            heightRectangle: this.heightRectangle,
            fileId: id
          });
          this.signPosition = this.signPosition.filter(sp => {
            return sp.fileId !== id;
          });
          this.signPosition.push({
            fileId: id,
            signType: SignPositionTypes.COMBINE,
            pageNumber: Number(pageIndex),
            x: 100 * wrapperLeft / zoomLevel,
            y: 100 * wrapperTop / zoomLevel,
            width: this.widthRectangle,
            height: this.heightRectangle,
            id: imageId,
            isNew: true
          });
          if (this.fileError.includes(fileId)) {
            this.fileError = this.fileError.filter(idFile => {
              return idFile !== fileId;
            });
          }
          // this.documentService.setSignPosition(this.signPosition);
          // console.log("this.imageData", this.imageData);
          // this.onStampSign(data);
        }
      });
      element.addEventListener('mousemove', (mousemoveEvent) => {
        if (this.isSelectPosition) {
          // xoá dòng chọn vị trí
          const node = element.querySelector('#show-frames-notification');
          const nodeOther = document.getElementById('show-frames-notification');
          if (!node && nodeOther) {
            nodeOther.remove();
          }
          const boundingClient = element.getBoundingClientRect();
          const {top, left} = boundingClient;
          const signatureWidth = this.widthRectangle * this.zoomLevel / 100;
          const heightRectangle = this.heightRectangle * this.zoomLevel / 100;
          if (!node) {
            const stampNode = document.createElement('div');
            stampNode.innerHTML = this.genStampContent();
            stampNode.style.position = 'absolute';
            stampNode.setAttribute('id', 'show-frames-notification');
            stampNode.style.left = `${(mousemoveEvent.clientX - signatureWidth / 2 - left)}px`;
            stampNode.style.top = `${(mousemoveEvent.clientY - heightRectangle / 2 - top)}px`;
            stampNode.style.width = `${signatureWidth}px`;
            stampNode.style.height = `${heightRectangle}px`;
            stampNode.style.zIndex = '1';
            stampNode.style.background = 'rgb(0,0,0,0.2)';
            stampNode.style.border = '1px solid';
            stampNode.style.lineHeight = '1.9';
            stampNode.style.color = '#00f';
            stampNode.style.fontFamily = 'Roboto, sans-serif';
            stampNode.style.padding = `${10 * this.zoomLevel / 100}px`;
            stampNode.style.fontSize = `${16 * this.zoomLevel / 100}px`;
            if (this.fileUpload) {
              stampNode.style.display = 'flex';
              stampNode.style.alignItems = 'center';
              stampNode.style.justifyContent = 'center';
            }

            element.appendChild(stampNode);

          } else {
            node.style.left = `${(mousemoveEvent.clientX - signatureWidth / 2 - left)}px`;
            node.style.top = `${(mousemoveEvent.clientY - heightRectangle / 2 - top)}px`;
          }
        }
      });
    }
    element.style.opacity = '1';
    element.setAttribute('id', `text-pdf-layer-${pageIndex}`);
    this.pageIndex++;
    if (this.isAllowSelectSignPosition && this.isSelectPosition) {
      this.onStamped();
    }
  }

  getStampWrapper(positionX: number, positionY: number, widthBase: number, heightBase: number, signType: string, id: string, element: any,
                  basePageIndex: number) {
    const positionData = this.signPosition.find(e => e.id === id);
    const width = positionData.width;
    const height = positionData.height;
    const stampNode = document.createElement('div');
    stampNode.setAttribute('id', `sign-${id}`);
    // const digitalNode = this.signPosition.find( e => e.x === positionX && e.y === positionY && e.signType === SignPositionTypes.DIGITAL);
    // let digitalElement;
    // if (digitalNode) {
    //   digitalElement = document.getElementById(`sign-${digitalNode.id}`);
    // }
    // stampNode.innerHTML = this.genStampContent();
    let signatureWidth = width * this.zoomLevel / 100;
    const heightRectangle = height * this.zoomLevel / 100;

    const wrapperLeft = (positionX * this.zoomLevel) / 100;
    const wrapperTop = (positionY * this.zoomLevel) / 100;
    const widthHeightRatio = width / height;

    // positionX: 100 * wrapperLeft / zoomLevel;
    // positionY: 100 * wrapperTop / zoomLevel;
    let {top, left} = element.getBoundingClientRect();
    const elementId = element.id.replace('text-pdf-layer-', '');
    stampNode.style.position = 'absolute';
    stampNode.style.left = `${wrapperLeft}px`;
    stampNode.style.top = `${wrapperTop}px`;
    stampNode.style.width = `${signatureWidth}px`;
    stampNode.style.height = `${heightRectangle}px`;
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    stampNode.style.lineHeight = '1.9';
    stampNode.style.color = '#00f';
    stampNode.style.fontFamily = 'Roboto, sans-serif';
    stampNode.style.padding = `${10 * this.zoomLevel / 100}px`;
    stampNode.style.fontSize = `${16 * this.zoomLevel / 100}px`;
    if (this.fileUpload) {
      stampNode.style.display = 'flex';
      stampNode.style.alignItems = 'center';
      stampNode.style.justifyContent = 'center';
    }

    stampNode.innerHTML = this.genStampContentWidthHeight(width, height, signType, !!positionData.isNew);
    stampNode.className = 'box-sign';
    // element.appendChild(stampNode);
    if (this.canMoveAndResize) {
      // move element
      let baseWrapperLeft;
      let baseWrapperTop;
      let signId;
      if (!positionData.isNew) {
        stampNode.style.cursor = 'move';
        stampNode.addEventListener('mousedown', (e) => {
          const targetSignId = e.target as Element;
          signId = targetSignId.id.replace('sign-', '');
          baseWrapperLeft = stampNode.offsetLeft;
          baseWrapperTop = stampNode.offsetTop;
          stampNode.innerHTML = `<div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;">
      <div id="notify_outside" style="position: absolute;top: -${35 * signZoom}px;left: ${(stampNode.offsetWidth / 2 - 150) * signZoom}px;color: red; width: ${300 * signZoom}px">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
        ${this.genStampContentWidthHeight(stampNode.offsetWidth, stampNode.offsetHeight, signType, !!positionData.isNew)}
      </div>`;

          document.documentElement.addEventListener('mousemove', doMove);
          document.documentElement.addEventListener('wheel', (wheelEvent) => {
            // stampNode.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
            // stampNode.style.top = `${(wheelEvent.clientY - heightRectangle / 2 - top)}px`;
            const elBounding = element.getBoundingClientRect();
            left = elBounding.left;
            top = elBounding.top;

          });
          document.documentElement.addEventListener('mouseup', stopMove);
        });
      }
      const signZoom = this.zoomLevel / 100;
      let goPage;
      // Move element sign
      const doMove = (e) => {
        // console.log(e);
        goPage = document.getElementById(`text-pdf-layer-${this.pageIndex}`);
        if (this.pageIndex + '' !== elementId && goPage) {
          const elBounding = goPage.getBoundingClientRect();
          left = elBounding.left;
          top = elBounding.top;
          stampNode.remove();
          goPage.appendChild(stampNode);
        } else {
          const elBounding = element.getBoundingClientRect();
          left = elBounding.left;
          top = elBounding.top;
          stampNode.remove();
          goPage.appendChild(stampNode);
        }
        stampNode.style.left = (e.clientX - stampNode.offsetWidth / 2 - left) + 'px';
        stampNode.style.top = (e.clientY - stampNode.offsetHeight / 2 - top) + 'px';
        // if (digitalElement) {
        //   digitalElement.style.left = (e.clientX - stampNode.offsetWidth / 2 - left) + 'px';
        //   digitalElement.style.top = (e.clientY - stampNode.offsetHeight / 2 - top) + 'px';
        // }
      };

      // stop move and save position
      const stopMove = (e) => {
        e.stopPropagation();
        if (stampNode.offsetWidth / 2 + stampNode.offsetLeft < 0
          || stampNode.offsetHeight / 2 + stampNode.offsetTop < 0
        ) {
          stampNode.style.left = baseWrapperLeft + 'px';
          stampNode.style.top = baseWrapperTop + 'px';
          this.pageIndex = basePageIndex;
        } else {
          baseWrapperLeft = stampNode.offsetLeft;
          baseWrapperTop = stampNode.offsetTop;
        }
        stampNode.innerHTML = this.genStampContentWidthHeight(stampNode.offsetWidth, stampNode.offsetHeight, signType, !!positionData.isNew);
        this.signPosition = this.signPosition.map(position => {
          if ((position.id === id) && position.fileId === fileId) {
            position.x = stampNode.offsetLeft / signZoom;
            position.y = stampNode.offsetTop / signZoom;
            position.pageNumber = this.pageIndex;
            // position.positionX = stampNode.offsetLeft / signZoom;
            // position.positionY = stampNode.offsetTop / signZoom;
            // position.pageNumber = this.pageIndex.toString();
          }
          return position;
        });
        this.imageData = this.imageData.map(position => {
          if ((position.id === id) && position.fileId === fileId) {
            position.positionX = stampNode.offsetLeft / signZoom;
            position.positionY = stampNode.offsetTop / signZoom;
            position.pageIndex = this.pageIndex;
            position.pageNumber = this.pageIndex;
          }
          return position;
        });
        rerenderSign();
        document.documentElement.removeEventListener('mousemove', doMove);
        document.documentElement.removeEventListener('mouseup', stopMove);
      };
      const fileId = this.decodeId(this.document.mainContractAttachments[this.activeFile].id);
      const resizer = document.createElement('div');
      resizer.setAttribute('class', 'resize-div-bot-right');
      resizer.style.setProperty('--zoom', signZoom.toString());
      const rerenderSign = () => {
        stampNode.appendChild(resizer);
        resizer.style.removeProperty('--zoom');
        resizer.style.setProperty('--zoom', (signZoom).toString());
        return;
      };
      if (signType !== SignPositionTypes.DIGITAL) {

        stampNode.appendChild(resizer);

        let startX, startY;
        let baseWidth;
        let baseHeight;
        resizer.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          startX = e.clientX;
          startY = e.clientY;
          const targetSignId = e.target as Element;
          signId = targetSignId.parentElement.id.replace('sign-', '');
          baseWidth = stampNode.offsetWidth;
          baseHeight = stampNode.offsetHeight;
          document.documentElement.addEventListener('mousemove', doDrag);
          document.documentElement.addEventListener('mouseup', stopDrag);

        });


        const doDrag = (e) => {
          e.stopPropagation();
          const signatureHeight = positionData.height * this.zoomLevel / 100;
          signatureWidth = positionData.width * this.zoomLevel / 100;
          stampNode.style.width = (signatureWidth + e.clientX - startX) + 'px';
          stampNode.style.height = (signatureHeight + e.clientY - startY) + 'px';
          const widthHeightRatioDrag = stampNode.offsetWidth / stampNode.offsetHeight;
          if (widthHeightRatio !== widthHeightRatioDrag) {
            stampNode.style.height = (stampNode.offsetWidth / widthHeightRatio) + 'px';
            stampNode.style.width = (stampNode.offsetHeight * widthHeightRatio) + 'px';
          }
          stampNode.style.maxWidth = (element.offsetWidth - stampNode.offsetLeft) + 'px';
          stampNode.style.maxHeight = (element.offsetHeight - stampNode.offsetTop) + 'px';
          // if (digitalElement) {
          //   digitalElement.style.height = stampNode.style.height;
          //   digitalElement.style.width = stampNode.style.width;
          //   digitalElement.style.maxWidth = (element.offsetWidth - stampNode.offsetLeft) + 'px';
          //   digitalElement.style.maxHeight = (element.offsetHeight - stampNode.offsetTop) + 'px';
          // }
          stampNode.innerHTML = this.genStampContentWidthHeight(Number(stampNode.offsetWidth), Number(stampNode.offsetHeight), signType, !!positionData.isNew);

          rerenderSign();
        };

        const stopDrag = (e) => {
          e.stopPropagation();
          if (stampNode.offsetWidth / 2 + wrapperLeft < 0 || stampNode.offsetHeight / 2 + wrapperTop < 0) {
            // stampNode.style.width = baseWidth + 'px';
            // stampNode.style.height = baseHeight + 'px';
          } else {
            baseWidth = stampNode.offsetWidth;
            baseHeight = stampNode.offsetHeight;
          }
          stampNode.innerHTML = this.genStampContentWidthHeight(Number(stampNode.offsetWidth), Number(stampNode.offsetHeight), signType, !!positionData.isNew);
          this.signPosition = this.signPosition.map(position => {
            if ((position.id === id) && position.fileId === fileId) {
              position.width = stampNode.offsetWidth;
              position.height = stampNode.offsetHeight;
            }
            return position;
          });
          this.imageData = this.imageData.map(position => {
            if ((position.id === id) && position.fileId === fileId) {
              position.widthRectangle = stampNode.offsetWidth;
              position.heightRectangle = stampNode.offsetHeight;
            }
            return position;
          });
          rerenderSign();
          document.documentElement.removeEventListener('mousemove', doDrag);
          document.documentElement.removeEventListener('mouseup', stopDrag);
        };
      }
      //    resize element
    }
    return stampNode;
  }

  genStampContentWidthHeight(widthRect: number, heightRect: number, signType: string, canNotMove: boolean): string {
    let contentNode: string;
    const padding = 10;
    const zoom = this.zoomLevel / 100;
    let widthRectangle = widthRect * zoom;
    let heightRectangle = heightRect * zoom;

    widthRectangle -= padding * zoom * 2;
    heightRectangle -= padding * zoom * 2;

    let height = widthRectangle;
    let width = heightRectangle;
    const ratio = this.imagePreviewWidth / this.imagePreviewHeight;
    if (this.imagePreviewWidth > this.imagePreviewHeight) {
      width = widthRectangle;
      height = width / ratio;
      if (height > heightRectangle) {
        height = heightRectangle;
        width = height * ratio;
      }
    } else {
      height = heightRectangle;
      width = height * ratio;
    }

    const heightPx = `${height}px`;
    const widthPx = `${width}px`;

    if (this.fileUpload) {
      // tslint:disable-next-line:max-line-length
      if (signType === SignPositionTypes.DIGITAL) {
        contentNode = `<div></div>`;
      } else {
        if (this.systemImageSign) {
          contentNode = `
          <i class="fa fa-undo" aria-hidden="true" style="display: ${this.canMoveAndResize && !canNotMove ? '' : 'none'};font-size: ${15 * zoom}px; position: absolute; top: 5px; right: 5px; cursor: move; height: unset; width: unset; color: red; z-index: 100;"></i>
          <img draggable="false" src="${this.imageUrlPreview}" style="transform: scale(${this.signConfig.signaturePosition.value === 'top' || this.signConfig.signaturePosition.value === 'bottom' ? (heightRectangle + 20) / this.heightImageRender : (widthRectangle + 20) / this.widthImageRender}); display: flex;
          justify-content:
          flex-end; align-items: flex-start; object-fit: cover;"/>
           `;
        } else {
          contentNode = `
          <i class="fa fa-undo" aria-hidden="true" style="display: ${this.canMoveAndResize && !canNotMove ? '' : 'none'};font-size: ${15 * zoom}px; position: absolute; top: 5px; right: 5px; cursor: move; height: unset; width: unset; color: red; z-index: 100;"></i>
                   <img draggable="false" src="${this.imageUrlPreview}" style="height: ${heightPx};width: ${widthPx}; max-width: ${this.signConfig.signaturePosition.value === 'left' || this.signConfig.signaturePosition.value === 'right' ? '1386px' : 'none'}; max-height: ${this.signConfig.signaturePosition.value === 'top' || this.signConfig.signaturePosition.value === 'bottom' ? '538px' : 'none'}; margin: auto; display: flex; justify-content: flex-end; align-items: flex-start;"/>
                    `;
        }
      }
    } else {
      const id = this.document.mainContractAttachments[this.activeFile].id;
      const fileId = this.decodeId(id);
      const signs = this.signPosition.filter(sign => {
        return sign.fileId === fileId;
      });
      if (this.selectedCert.typeCertificate === this.signMethod.SIGN_OTP && ((signs && signs.length > 0) || (signs && signs.length === 0))) {
        if (signType === SignPositionTypes.DIGITAL) {
          contentNode = `<div></div>`;
        } else {
          contentNode = `
            <div>
                ${this.isSignDigitalCertificate ? this.translateService.instant('enterprise_contract.image_signing.no_image.approver_by') : this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.enterpriseName}
                <br/>
                ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_phone')} ${this.selectedCert.phoneNumber}
                <br/>
                ${this.isSignDigitalCertificate ? this.translateService.instant('enterprise_contract.image_signing.no_image.approver_date') : this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
                ${this.isNotAttestedUser ? '' : '<br/>'}
                ${this.isNotAttestedUser ? '' : this.translateService.instant('enterprise_contract.image_signing.no_image.verified_info')}
              </div>
            `;
        }
      } else if (this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT && ((signs.length && signs.length > 0) || (signs && signs.length === 0))) {
        if (signType === SignPositionTypes.DIGITAL) {
          contentNode = `<div></div>`;
        } else {
          contentNode = `
            <div>
                ${this.isSignDigitalCertificate ? this.translateService.instant('enterprise_contract.image_signing.no_image.approver_by') : this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.enterpriseName}
                  <br/>
                ${this.isSignDigitalCertificate ? this.translateService.instant('enterprise_contract.image_signing.no_image.approver_date') : this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
                ${this.isNotAttestedUser ? '' : '<br/>'}
                ${this.isNotAttestedUser ? '' : this.translateService.instant('enterprise_contract.image_signing.no_image.verified_info')}
             </div>
          `;
        }
      } else if ((signs && signs.length > 1) || (signs && signs.length === 0)) {
        if (signType === SignPositionTypes.DIGITAL) {
          contentNode = `<div></div>`;
        } else {
          contentNode = `<div>
                ${this.isSignDigitalCertificate ? this.translateService.instant('enterprise_contract.image_signing.no_image.approver_by') : this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.selectedCert.issuedTo}
              <br/>
                ${this.isSignDigitalCertificate ? this.translateService.instant('enterprise_contract.image_signing.no_image.approver_date') : this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
            </div>`;
        }
      } else if (signs && signs.length === 1 && signs[0].signType === SignPositionTypes.DIGITAL) {
        contentNode = `<div></div>`;
      } else if (signs && signs.length === 1 && signs[0].signType !== SignPositionTypes.DIGITAL) {
        contentNode = `<div>
                ${this.isSignDigitalCertificate ? this.translateService.instant('enterprise_contract.image_signing.no_image.approver_by') : this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.selectedCert.issuedTo}
              <br/>
                ${this.isSignDigitalCertificate ? this.translateService.instant('enterprise_contract.image_signing.no_image.approver_date') : this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
            </div>`;
      }
    }
    return contentNode;
  }

  genStampContent() {
    let contentNode: string;
    const padding = 10;
    const zoom = this.zoomLevel / 100;
    let widthRectangle = this.widthRectangle * zoom;
    let heightRectangle = this.heightRectangle * zoom;

    widthRectangle -= padding * zoom * 2;
    heightRectangle -= padding * zoom * 2;

    let height = widthRectangle;
    let width = heightRectangle;
    const ratio = this.imagePreviewWidth / this.imagePreviewHeight;
    if (this.imagePreviewWidth > this.imagePreviewHeight) {
      width = widthRectangle;
      height = width / ratio;
      if (height > heightRectangle) {
        height = heightRectangle;
        width = height * ratio;
      }
    } else {
      height = heightRectangle;
      width = height * ratio;
    }

    const heightPx = `${height}px`;
    const widthPx = `${width}px`;
    if (this.fileUpload) {
      let contentInsideNode = '';
      if (this.systemImageSign) {
        contentInsideNode = `
        <img draggable="false" src="${this.imageUrlPreview}" style="transform: scale(${this.signConfig.signaturePosition.value === 'top' || this.signConfig.signaturePosition.value === 'bottom' ? (heightRectangle + 20) / this.heightImageRender : (widthRectangle + 20) / this.widthImageRender}); display: flex; justify-content: flex-end; align-items: flex-start; object-fit: cover;"/>
         `;
      } else {
        contentInsideNode = `
       <img draggable="false" src="${this.imageUrlPreview}" style="height: ${heightPx};width: ${widthPx}; max-width: ${this.signConfig.signaturePosition.value === 'left' || this.signConfig.signaturePosition.value === 'right' ? '1386px' : 'none'}; max-height: ${this.signConfig.signaturePosition.value === 'top' || this.signConfig.signaturePosition.value === 'bottom' ? '538px' : 'none'}; margin: auto; display: flex; justify-content: flex-end; align-items: flex-start;"/>
                  `;
      }
      // tslint:disable-next-line:max-line-length
      contentNode = `
                 <div id="notify_outside" style="position: absolute;top: -40px;left: 33px;color: red;">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
                 ${contentInsideNode}
                  `;
    } else {
      const id = this.document.mainContractAttachments[this.activeFile].id;
      const fileId = this.decodeId(id);
      const signs = this.signPosition.filter(sign => {
        return sign.fileId === fileId;
      });
      if (this.selectedCert.typeCertificate === this.signMethod.SIGN_OTP && ((signs && signs.length > 0 && signs[0].signType !== SignPositionTypes.DIGITAL) || (signs && signs.length === 0))) {
        contentNode = `
      <div>
            <div id="notify_outside" style="position: absolute;top: -40px;left: 33px;color: red;">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
                ${this.isSignDigitalCertificate ? this.translateService.instant('enterprise_contract.image_signing.no_image.approver_by') : this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.enterpriseName}
              <br/>
              ${this.translateService.instant('enterprise_contract.image_signing.no_image.signed_phone')} ${this.selectedCert.phoneNumber}
              <br/>
                ${this.isSignDigitalCertificate ? this.translateService.instant('enterprise_contract.image_signing.no_image.approver_date') : this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
              ${this.isNotAttestedUser ? '' : '<br/>'}
              ${this.isNotAttestedUser ? '' : this.translateService.instant('enterprise_contract.image_signing.no_image.verified_info')}
            </div>
      `;
      } else if ((this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT
        || this.selectedCert.typeCertificate === this.signMethod.SIGN_EKYC
        || this.selectedCert.typeCertificate === this.signMethod.SIGN_EKYC_ADVANCED)
        && ((signs && signs.length > 0 && signs[0].signType !== SignPositionTypes.DIGITAL) || (signs && signs.length === 0))) {
        contentNode = `
        <div>
               <div id="notify_outside" style="position: absolute;top: -40px;left: 60px;color: red;">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
                ${this.isSignDigitalCertificate ? this.translateService.instant('enterprise_contract.image_signing.no_image.approver_by') : this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.enterpriseName}
              <br/>
                ${this.isSignDigitalCertificate ? this.translateService.instant('enterprise_contract.image_signing.no_image.approver_date') : this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
              ${this.isNotAttestedUser ? '' : '<br/>'}
              ${this.isNotAttestedUser ? '' : this.translateService.instant('enterprise_contract.image_signing.no_image.verified_info')}
         </div>
      `;
      } else if ((signs && signs.length > 0 && signs[0].signType !== SignPositionTypes.DIGITAL) || (signs && signs.length === 0)) {
        contentNode = `<div>
              <div id="notify_outside" style="position: absolute;top: -40px;left: 33px;color: red;">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
                ${this.isSignDigitalCertificate ? this.translateService.instant('enterprise_contract.image_signing.no_image.approver_by') : this.translateService.instant('enterprise_contract.image_signing.no_image.signed_by')} ${this.selectedCert.issuedTo}
              <br/>
                ${this.isSignDigitalCertificate ? this.translateService.instant('enterprise_contract.image_signing.no_image.approver_date') : this.translateService.instant('enterprise_contract.image_signing.no_image.signed_date')} ${this.dateNow}
            </div>`;
      } else if (signs && signs.length === 1 && signs[0].signType === SignPositionTypes.DIGITAL) {
        contentNode = `<div></div>`;
      }
    }
    return contentNode;
  }

  blobToSrc(blob: any) {
    return new Promise((resolve, reject) => {
      try {
        const file = this.blobToFile(blob, 'application/pdf');
        this.commonService.readFile(file, (pdfSrc) => {
          // if(!this.listPdfSrc){
          //   this.listPdfSrc = {}
          // }
          // this.listPdfSrc[pdfFilePath] = pdfSrc;
          // this.document.mainContractAttachments.forEach(item => {
          //   if (item.path == pdfFilePath) {
          //     item.loading = false;
          //   }
          // });
          resolve(pdfSrc)
        });
      } catch (e) {
        reject(e);
      }
    })
  }

  showPdf(blob: any, pdfFilePath: string) {
    return new Promise((resolve, reject) => {
      try {
        const file = this.blobToFile(blob, 'application/pdf');
        this.commonService.readFile(file, (pdfSrc) => {
          this.pdfSrc = pdfSrc;
          if (!this.listPdfSrc) {
            this.listPdfSrc = {}
          }
          this.listPdfSrc[pdfFilePath] = pdfSrc;
          this.document.mainContractAttachments.forEach(item => {
            if (item.path == pdfFilePath) {
              item.loading = false;
            }
          });
          resolve(pdfSrc)
        });
      } catch (e) {
        reject(e);
      }
    })
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  }

  gotoSignPage() {
    const signPage = this.signPage || 1;
    this.pageCurrent = signPage;
    // const textLayer = document.getElementById(`text-pdf-layer-${Number(signPage)}`);
    // if (textLayer) {
    //   textLayer.scrollIntoView();
    // }
  }

  gotoSignPageNumber(signPage: number) {
    this.pageCurrent = signPage;
  }

  onStamped() {
    this.isSelectPosition = true;
    const id = this.document.mainContractAttachments[this.activeFile].id;
    const fileId = this.decodeId(id);
    if (fileId && this.signPosition && this.signPosition.length > 0) {
      this.signPosition = this.signPosition.filter(sign => {
        return sign.fileId !== fileId;
      });
    }
    if (fileId && this.imageData && this.imageData.length > 0) {
      this.imageData = this.imageData.filter(image => {
        return image.fileId !== fileId;
      });
    }
    const listElement = document.getElementsByClassName('box-sign');
    if (listElement && listElement.length) {
      listElement.item(0).remove();
    }
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    if (this.current > 0) {
      this.showFramesNotification();
    }
  }

  showFramesNotification() {
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    const navBoundingClient = this.navigation.nativeElement.getBoundingClientRect();
    const {top, left, bottom, width, height} = navBoundingClient;
    const signatureWidth = this.widthRectangle * this.zoomLevel / 100;
    const heightRectangle = this.heightRectangle * this.zoomLevel / 100;
    const navigation = document.getElementById('navigation');
    const newTop = top - 2 * heightRectangle;
    const newLeft = width / 2 - signatureWidth / 2;
    const stampNode = document.createElement('div');
    stampNode.setAttribute('id', 'show-frames-notification');
    const contentNode = `<span style="color: red;">${this.translateService.instant('messages.click_to_select_sign_position')}</span>`;
    stampNode.style.position = 'absolute';
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.innerHTML = contentNode;
    stampNode.style.left = `${newLeft}px`;
    stampNode.style.top = `${newTop}px`;
    stampNode.style.width = `${signatureWidth}px`;
    stampNode.style.height = `${heightRectangle}px`;
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    if (this.fileUpload) {
      stampNode.style.display = 'flex';
      stampNode.style.alignItems = 'center';
      stampNode.style.justifyContent = 'center';
    }

    this.stampWrapper = stampNode;
    navigation.appendChild(stampNode);
  }

  pageRendered(e) {
    // if (e.pageNumber >= Number(this.signPage)) {
    //   if (this.signPosition.length > 0) {
    //     const firstSignPosition = this.signPosition[0];
    //     this.signPage = firstSignPosition.pageNumber;
    //
    //   }
    // }
    // this.thumbnail.push({
    //   page: e.pageNumber,
    //   url: e.source.canvas.toDataURL()
    // });
  }

  gotoPage(page: number) {
    const textLayer = document.getElementById(`text-pdf-layer-${page - 1}`);
    if (textLayer) {
      textLayer.scrollIntoView();
    }
  }

  private processSignServer() {
    this.signDocumentService.signatureServer(this.sign).subscribe(rs => {
      this.onSignSuccess();
    });
  }

  private async processSignServerImage() {
    const id = this.commonService.generateUUID();
    this.processingId = id;
    const sign = JSON.parse(JSON.stringify(this.sign));
    sign.signTransactionCode = this.commonService.generateUUID();
    sign.signPositions = JSON.stringify(this.signProcessing);
    sign.image = this.fileUpload;
    sign.message = this.messageSign;
    this.getApiSignImageSystem(this.signDocumentService.signatureServerImageBase64, sign);

    this.signingProcess(sign.signTransactionCode)
  }

  async processSignSimCA() {
    this.sign.phoneNumber = this.certificate.phoneNumber;
    this.sign.serialNumber = this.certificate.serialNumber;
    let isSuccess = true;
    const filePath = {};
    const mainContractAttachmentsNew = [];
    for await (const img of this.signProcessing) {
      if (this.isCancel) {
        isSuccess = false;
        break;
      }
      const sign = JSON.parse(JSON.stringify(this.sign));
      sign.position = img;
      sign.message = this.messageSign;
      const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === img.fileId);
      sign.path = file && file.path ? file.path : null;
      sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : '';
      let res
      if (this.systemImageSign && this.fileUpload) {
        const newDate = await this.signDocumentService.getDateAsync().toPromise();
        const email = await this.signDocumentService.getEmailAsync().toPromise();
        if (!newDate || !newDate.data || !newDate.data.date) {
          return;
        }
        this.signConfig.signingTime.value = newDate.data.date;
        this.signConfig.email.value = email.data;
        // gen lại image

        this.cd.detectChanges();
        let blob = null;
        try {
          let imageSize = this.setSizeFrameImage();
          blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
        } catch (e) {
          console.log("call api error, use html to image", e);
          try {
            let imageSize = this.setSizeFrameImage();
            blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
          } catch (e) {
            console.log("call api error, use html to image", e);
          }
        }

        if(!blob){
          this.toastr.error(this.message.getMessage('messages.error_proccessing'));
          isSuccess = false;
          break;
        }

        const file = new File([blob], 'lastImage.png', {type: 'image/png'});
        this.fileUpload = file;

        sign.image = this.fileUpload;

        res = await this.signDocumentService.signSimCAWithImageBase64(sign);
      } else {
        res = await this.signDocumentService.signSimCAWithImageBase64(sign);
      }

      if (res && !res.success) {
        isSuccess = false;
        if (!this.isCancelSign) {
          this.signError = res && res.message ? res.message : null;
        }
        // if (!this.isCancel) {
        //   this.toastr.error(res.message);
        // }
        break;
      }
      if (!res || !res.data) {
        isSuccess = false;
        break;
      } else {
        filePath[img.fileId] = res.data.path;
        const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
        if (!contractAttachment) {
          const contractAttachmentNew = JSON.parse(JSON.stringify(file));
          contractAttachmentNew.path = res.data.path;
          mainContractAttachmentsNew.push(contractAttachmentNew);
        } else {
          contractAttachment.path = res.data.path;
        }
        if (!this.isCancel) {
          img.done = true;
        }
      }
    }
    if (this.isCancel) {
      isSuccess = false;
    }
    const data = {
      signTransactionId: this.signTransactionId,
      userCancel: this.userCancel,
      signMethod: this.selectedCert.typeCertificate,
      contractId: this.document.id,
      mainContractAttachments: mainContractAttachmentsNew,
      certificate: this.sign.certificate,
      digitalCertificateDetailId: this.selectedCert.idDetail,
      phoneNumber: this.selectedCert.phoneNumber,
      serialNumber: this.selectedCert.serialNumber,
      message: this.messageSign
    };
    if (isSuccess) {
      this.isCallDone = true;
      this.signDocumentService.signDone(data).subscribe(res => {
          if (res && res.data) {
            this.onSignSuccess();
          } else {
            this.isCallDone = false;
          }
        },
        err => {
          this.errorStatus = this.message.getMessage('messages.sign_fail');
        })
      // const res = await this.signDocumentService.signDone(data).toPromise();
      // if (res && res.data) {
      //   this.onSignSuccess();
      // } else {
      //   this.isCallDone = false;
      // }
    } else {
      this.errorStatus = "messages.stop_sign_document";
      this.signDocumentService.signCancel(data).subscribe(res => {
        // this.errorStatus = "messages.stop_sign_document";
      });
    }
  }

  async processSignSimCAImage() {
    // let isSuccess = true;
    // const filePath = {};
    // const mainContractAttachmentsNew = [];
    const id = this.commonService.generateUUID();
    this.processingId = id;
    const sign = JSON.parse(JSON.stringify(this.sign));
    sign.signTransactionCode = this.commonService.generateUUID();
    sign.signPositions = JSON.stringify(this.signProcessing);
    sign.image = this.fileUpload;
    sign.message = this.messageSign;
    this.getApiSignImageSystem(this.signDocumentService.signSimCAWithImageBase64, sign);

    this.signingProcess(sign.signTransactionCode)
    // for await (const img of this.signProcessing) {
    //   if (this.isCancel) {
    //     isSuccess = false;
    //     break;
    //   }
    //   const sign = JSON.parse(JSON.stringify(this.sign));
    //   sign.position = JSON.stringify(img);
    //   const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === img.fileId);
    //   sign.path = file && file.path ? file.path : null;
    //   sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : '';
    //   sign.image = this.fileUpload;
    //   const res = await this.signDocumentService.signSimCAWithImage(sign).toPromise();
    //   if (id !== this.processingId) {
    //     return;
    //   }
    //   if (res && !res.success) {
    //     isSuccess = false;
    //     if (!this.isCancelSign) {
    //       this.signError = res && res.message ? res.message : null;
    //     }
    //     // if (!this.isCancel) {
    //     //   this.toastr.error(res.message);
    //     // }
    //     break;
    //   }
    //   if (!res || !res.data) {
    //     isSuccess = false;
    //     break;
    //   } else {
    //     filePath[img.fileId] = res.data.path;
    //     const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
    //     if (!contractAttachment) {
    //       const contractAttachmentNew = JSON.parse(JSON.stringify(file));
    //       contractAttachmentNew.path = res.data.path;
    //       mainContractAttachmentsNew.push(contractAttachmentNew);
    //     } else {
    //       contractAttachment.path = res.data.path;
    //     }
    //     if (!this.isCancel) {
    //       img.done = true;
    //     }
    //   }
    // }
    // if (this.isCancel) {
    //   isSuccess = false;
    // }
    // const data = {
    //   signTransactionId: this.signTransactionId,
    //   userCancel: this.userCancel,
    //   signMethod: this.selectedCert.typeCertificate,
    //   contractId: this.document.id,
    //   mainContractAttachments: mainContractAttachmentsNew,
    //   certificate: this.sign.certificate,
    //   digitalCertificateDetailId: this.selectedCert.idDetail,
    //   phoneNumber: this.selectedCert.phoneNumber,
    //   serialNumber: this.selectedCert.serialNumber
    // }
    // if (isSuccess) {
    //   this.isCallDone = true;
    //   this.signDocumentService.signDone(data).subscribe(res => {
    //     if (res && res.data) {
    //       this.onSignSuccess();
    //     } else {
    //       this.isCallDone = false;
    //     }
    //   },
    //     err => {
    //       this.errorStatus = this.message.getMessage('messages.sign_fail');
    //     })
    //   // const res = await this.signDocumentService.signDone(data).toPromise();
    //   // if (res && res.data) {
    //   //   this.onSignSuccess();
    //   // } else {
    //   //   this.isCallDone = false;
    //   // }
    // } else {
    //   this.errorStatus = "messages.stop_sign_document";
    //   this.signDocumentService.signCancel(data).subscribe(res => {
    //     // this.errorStatus = "messages.stop_sign_document";
    //   });
    // }
  }

  async processSignCloudCA() {
    // let isSuccess = true;
    const filePath = {};
    // const mainContractAttachmentsNew = [];
    const _data = [];
    const hashMap = {};
    let id = 0;
    const processingId = this.commonService.generateUUID();
    this.processingId = processingId;
    let signPositions: any[] = []
    for (const item of this.signProcessing) {
      item.index = id;
      const fileId = item.fileId;
      if (fileId in hashMap) {
        hashMap[fileId].push({
          ...item
        })
      } else {
        hashMap[fileId] = [{
          ...item
        }]
      }
      id++;
    }

    for (const key in hashMap) {
      _data.push({
        fileId: Number(key),
        listSignPosition: hashMap[key],
        ...this.sign
      })
    }
    // tìm số chữ ký nhiều nhất
    let maxSignPosition = 0;
    for (const item of _data) {
      if (item.listSignPosition.length > maxSignPosition) {
        maxSignPosition = item.listSignPosition.length
      }
    }
    // // số vòng lặp bằng số position lớn nhất
    for (let i = 0; i < this.signProcessing.length; i++) {
      // lặp số lần bằng số file
      let request = [];
      for (const dataItem of _data) {
        if (dataItem.listSignPosition[i]) {
          const position = dataItem.listSignPosition[i];
          let requestItem = {
            ...this.sign,
            fileId: dataItem.fileId,
            position: position,
            image: null,
            signProcessingId: position.index
          };
          const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === dataItem.fileId);
          requestItem.path = file && file.path ? file.path : null;
          requestItem.oldPath = filePath[requestItem.fileId] ? filePath[requestItem.fileId] : '';
          // if (this.fileUpload) {
          //   requestItem.image = this.fileUpload;
          // }
          signPositions.push(requestItem);
        }
      }
    }
    const newRequest = {
      ...this.sign,
      listSignPosition: signPositions,
      signTransactionCode: this.commonService.generateUUID(),
      message: this.messageSign
    };
    if (this.fileUpload) {
      const imageRequest = {
        ...this.sign,
        image: this.fileUpload,
        signTransactionCode: this.commonService.generateUUID(),
        listSignPosition: JSON.stringify(signPositions),
        message: this.messageSign
      };
      this.getApiSignImageSystem(this.signDocumentService.signCloudCAWithImageBase64, imageRequest);

      this.signingProcess(imageRequest.signTransactionCode)
    } else {
      this.signDocumentService.signCloudCANoImage(newRequest).subscribe(res => {
      })
      this.signingProcess(newRequest.signTransactionCode)
    }

    // const newRequest = {
    //   ...this.sign,
    //   listSignPosition: request
    // };
    // let res = undefined;
    // if (this.fileUpload) {
    //   const imageRequest = {
    //     ...newRequest,
    //     image: this.fileUpload,
    //     listSignPosition: JSON.stringify(newRequest.listSignPosition)
    //   };
    //   res = await this.signDocumentService.signCloudCAWithImage(imageRequest).toPromise();
    // } else {
    //   // sign.position = img;
    //   res = await this.signDocumentService.signCloudCANoImage(newRequest).toPromise();
    // }

    // if (this.processingId != processingId) {
    //   return;
    // }

    // if (res && !res.success) {
    //   isSuccess = false;
    //   if (!this.isCancelSign) {

    //     this.signError = res && res.message ? res.message : null;
    //   }
    //   // if (!this.isCancel) {
    //   //   this.toastr.error(res.message);
    //   // }
    //   break;
    // }

    // if (!res || !res.data) {
    //   isSuccess = false;
    //   break;
    // } else {
    //   // update lại đường dẫn của mainContractAttachments tương ứng
    //   for (const item of res.data) {
    //     const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) == item.fileId);
    //     filePath[item.fileId] = item.path;
    //     const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id == file.id);
    //     if (!contractAttachment) {
    //       const contractAttachmentNew = JSON.parse(JSON.stringify(file));
    //       contractAttachmentNew.path = item.path;
    //       mainContractAttachmentsNew.push(contractAttachmentNew);
    //     } else {
    //       contractAttachment.path = item.path;
    //     }
    //   }
    //   if (!this.isCancel) {
    //     for (const it of newRequest.listSignPosition) {
    //       for (let j = 0; j < this.signProcessing.length; j++) {
    //         if (this.signProcessing[j].index == it.signProcessingId) {
    //           this.signProcessing[j].done = true;
    //         }
    //       }
    //     }
    //     // item.done = true;
    //   }
    // }
    // }
    // if (this.isCancel) {
    //   isSuccess = false;
    // }
    // const data = {
    //   signTransactionId: this.signTransactionId,
    //   userCancel: this.userCancel,
    //   signMethod: this.selectedCert.typeCertificate,
    //   contractId: this.document.id,
    //   mainContractAttachments: mainContractAttachmentsNew,
    //   certificate: this.sign.certificate,
    //   digitalCertificateDetailId: this.selectedCert.idDetail,
    //   phoneNumber: this.selectedCert.phoneNumber,
    //   serialNumber: this.selectedCert.serialNumber
    // };
    // if (isSuccess) {
    //   this.isCallDone = true;
    //   this.signDocumentService.signDone(data).subscribe(res => {
    //     if (res && res.data) {
    //       this.onSignSuccess();
    //     } else {
    //       this.isCallDone = false;
    //     }
    //   },
    //     err => {
    //       this.errorStatus = this.message.getMessage('messages.sign_fail');
    //     })
    //   // const res = await this.signDocumentService.signDone(data).toPromise();
    //   // if (res && res.data) {
    //   //   isDone = true;
    //   //   this.onSignSuccess();
    //   // } else {
    //   //   isDone = true;
    //   //   this.isCallDone = false;
    //   // }
    //   // if(!isDone){
    //   //   // this.errorStatus = this.message.getMessage('messages.sign_fail');
    //   //   this.onSignbBeforeDone()
    //   // }
    // } else {
    //   this.errorStatus = "messages.stop_sign_document";
    //   this.signDocumentService.signCancel(data).subscribe(res => {
    //     // this.errorStatus = "messages.stop_sign_document";
    //   });
    // }
  }

  processSignOTP() {
    this.sign = {
      contractId: this.contractId,
      digitalCertificateId: this.selectedCert.id,
      digitalCertificateDetailId: this.selectedCert.idDetail,
      ...this.selectedCert
    };
    let signMethod = this.selectedCert.typeCertificate;
    if (this.isShowEKYC) {
      if (this.ekycSupportConfig === 1) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC;
      } else if (this.ekycSupportConfig === 2) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC_ADVANCED;
      }
    }
    let request = {
      signMethod: signMethod,
      signPositions: this.signImages
    }
    this.signDocumentService.generateTransaction(this.sign.contractId, this.selectedCert.phoneNumber, request).subscribe(rs => {
      if (!rs.success) {
        if (rs.code === ErrorCode.OutOfMoneyOtp) {
          this.toastr.error(this.message.getMessage('messages.otp_out_of_money'));
        } else if (rs.code === ErrorCode.OutOfMoneyOtpNew) {
          this.toastr.error(this.message.getMessage('messages.otp_out_of_money_new'));
        } else {
          this.toastr.error(rs.message);
        }
      } else {
        this.openDialogConfirmSignOTP(rs.data);
      }
    });
  }

  async processSignNoCertificate() {

    this.dialogRef = this.dialog.open(SigningDialogComponent, {
      width: '80%',
      disableClose: true,
      data: this
    });
    this.dialogRef.afterClosed().subscribe(() => {
      this.signProcessing = [];
      this.errorStatus = null;
      this.signError = null;
      this.isCancel = false;
      this.isCallDone = false;
      this.processingId = null;
      this.dialog.closeAll();
    });
    let isSuccess = true;
    const filePath = {};
    const mainContractAttachmentsNew = [];
    for await (const img of this.signProcessing) {
      if (this.isCancel) {
        isSuccess = false;
        break;
      }
      const sign = JSON.parse(JSON.stringify(this.sign));
      sign.position = JSON.stringify(img);
      const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === img.fileId);
      sign.path = file && file.path ? file.path : null;
      sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : '';
      sign.image = this.fileUpload;
      // const res = await api.toPromise().catch(err => {
      //   this.errorStatus = this.message.getMessage('messages.sign_fail');
      // });
      let res;

      if (this.systemImageSign && this.fileUpload) {
        const newDate = await this.signDocumentService.getDateAsync().toPromise();
        const email = await this.signDocumentService.getEmailAsync().toPromise();
        if (!newDate || !newDate.data || !newDate.data.date) {
          return;
        }

        this.signConfig.signingTime.value = newDate.data.date;
        this.signConfig.email.value = email.data;

        this.cd.detectChanges();
        let blob = null;
        try {
          let imageSize = this.setSizeFrameImage();
          blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
        } catch (e) {
          console.log("call api error, use html to image", e);
          try {
            let imageSize = this.setSizeFrameImage();
            blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
          } catch (e) {
            console.log("call api error, use html to image", e);
          }
        }

        if(!blob){
          this.toastr.error(this.message.getMessage('messages.error_proccessing'));
          isSuccess = false;
          break;
        }
        // const blob = await htmlToImage.toBlob(this.domRenderImage.nativeElement)
        const newFile = new File([blob], 'lastImage.png', {type: 'image/png'});
        this.fileUpload = newFile;

        sign.image = this.fileUpload;

        res = await this.signDocumentService.signWithImageNoCertificateBase64(sign).catch(err => {
          this.errorStatus = this.message.getMessage('messages.sign_fail');
        });

        if (res && !res.success) {
          isSuccess = false;
          this.signError = res && res.message ? res.message : null;
          break;
        } else if (!res || !res.data) {
          isSuccess = false;
          break;
        } else {
          filePath[img.fileId] = res.data.path;
          const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
          if (!contractAttachment) {
            const contractAttachmentNew = JSON.parse(JSON.stringify(file));
            contractAttachmentNew.path = res.data.path;
            mainContractAttachmentsNew.push(contractAttachmentNew);
          } else {
            contractAttachment.path = res.data.path;
          }
          if (!this.isCancel) {
            img.done = true;
          }
        }
      } else {
        res = await this.signDocumentService.signWithImageNoCertificateBase64(sign).catch(err => {
          this.errorStatus = this.message.getMessage('messages.sign_fail');
        });

        if (res && !res.success) {
          isSuccess = false;
          this.signError = res && res.message ? res.message : null;
          break;
        }
        if (!res || !res.data) {
          isSuccess = false;
          break;
        } else {
          filePath[img.fileId] = res.data.path;
          const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
          if (!contractAttachment) {
            const contractAttachmentNew = JSON.parse(JSON.stringify(file));
            contractAttachmentNew.path = res.data.path;
            mainContractAttachmentsNew.push(contractAttachmentNew);
          } else {
            contractAttachment.path = res.data.path;
          }
          if (!this.isCancel) {
            img.done = true;
          }
        }
      }
    }
    if (this.isCancel) {
      isSuccess = false;
    }
    let signMethod = this.selectedCert.typeCertificate;
    if (this.isShowEKYC) {
      if (this.ekycSupportConfig === 1) {
        signMethod = EnumSignMethod.SIGN_NO_CERT_EKYC;
      } else if (this.ekycSupportConfig === 2) {
        signMethod = EnumSignMethod.SIGN_NO_CERT_EKYC_ADVANCED;
      }
    }
    const data = {
      signMethod,
      signTransactionId: this.signTransactionId,
      userCancel: this.userCancel,
      contractId: this.document.id,
      mainContractAttachments: mainContractAttachmentsNew,
      certificate: this.sign.certificate,
      digitalCertificateDetailId: this.selectedCert.idDetail,
      message: this.messageSign
    }
    if (isSuccess) {
      this.isCallDone = true;
      this.signDocumentService.signDone(data).subscribe(res => {
          if (res && res.data) {
            this.onSignSuccess();
          } else {
            this.isCallDone = false;
          }
        },
        err => {
          this.errorStatus = this.message.getMessage('messages.sign_fail');
        })
      // const res = await this.signDocumentService.signDone(data).toPromise();
      // if (res && res.data) {
      //   this.onSignSuccess();
      // } else {
      //   this.isCallDone = false;
      // }
    } else {
      this.errorStatus = "messages.stop_sign_document";
      this.signDocumentService.signCancel(data).subscribe(res => {
        // this.errorStatus = "messages.stop_sign_document";
      });
    }
  }

  resetValue() {
    this.errorStatus = null;
    this.signError = null;
    this.isCancel = false;
    this.isCallDone = false;
  }

  async processSignHSM() {
    let isSuccess = true;
    for await (const img of this.signProcessing) {
      const sign = JSON.parse(JSON.stringify(this.sign));
      sign.position = img;
      if (this.fileUpload) {
        sign.image = this.fileUpload;
      }
      if (this.isCancel) {
        isSuccess = false;
        break;
      }

      this.getApiSignImageSystem(this.signDocumentService.signHSM, sign)
      if (this.isCancel) {
        isSuccess = false;
        break;
      }
      // if (!res || !res.data) {
      //   isSuccess = false;
      //   break;
      // }
    }
    const data = {
      signTransactionId: this.signTransactionId,
      userCancel: this.userCancel,
      signMethod: this.selectedCert.typeCertificate,
      contractId: this.document.id,
      // mainContractAttachments: mainContractAttachmentsNew,
      certificate: this.sign.certificate,
      digitalCertificateDetailId: this.selectedCert.idDetail
    }
    // if (isSuccess) {
    //   this.isCallDone = true;
    //         const res = await this.signDocumentService.signDone(data).toPromise();
    //         if (res && res.data) {
    //           this.onSignSuccess();
    //         } else {
    //           this.isCallDone = false;
    //         }
    // }
  }

  async processSignSimCANoImage() {
    // let isSuccess = true;
    // const filePath = {};
    // const mainContractAttachmentsNew = [];
    const id = this.commonService.generateUUID();
    this.processingId = id;
    const sign = JSON.parse(JSON.stringify(this.sign));
    sign.signTransactionCode = this.commonService.generateUUID();
    sign.signPositions = this.signProcessing
    sign.message = this.messageSign;
    this.signDocumentService.signSimCANoImage(sign).subscribe(res => {
    })
    this.signingProcess(sign.signTransactionCode)

    // for await (const img of this.signProcessing) {
    //   if (this.isCancel) {
    //     isSuccess = false;
    //     break;
    //   }
    //   const sign = JSON.parse(JSON.stringify(this.sign));
    //   sign.position = img;
    //   const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === img.fileId);
    //   sign.path = file && file.path ? file.path : null;
    //   sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : '';
    //   const res = await this.signDocumentService.signSimCANoImage(sign).toPromise();
    //   if (id !== this.processingId) {
    //     return;
    //   }
    //   if (res && !res.success) {
    //     isSuccess = false;
    //     if (!this.isCancelSign) {
    //       this.signError = res && res.message ? res.message : null;
    //     }
    //     // if (!this.isCancelSign) {
    //     //   this.toastr.error(res.message);
    //     // }
    //     break;
    //   }
    //   if (!res || !res.data) {
    //     isSuccess = false;
    //     break;
    //   } else {
    //     filePath[img.fileId] = res.data.path;
    //     const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
    //     if (!contractAttachment) {
    //       const contractAttachmentNew = JSON.parse(JSON.stringify(file));
    //       contractAttachmentNew.path = res.data.path;
    //       mainContractAttachmentsNew.push(contractAttachmentNew);
    //     } else {
    //       contractAttachment.path = res.data.path;
    //     }
    //     if (!this.isCancel) {
    //       img.done = true;
    //     }
    //   }
    // }
    // if (this.isCancel) {
    //   isSuccess = false;
    // }
    // const data = {
    //   signTransactionId: this.signTransactionId,
    //   userCancel: this.userCancel,
    //   signMethod: this.selectedCert.typeCertificate,
    //   contractId: this.document.id,
    //   mainContractAttachments: mainContractAttachmentsNew,
    //   certificate: this.sign.certificate,
    //   digitalCertificateDetailId: this.selectedCert.idDetail,
    //   phoneNumber: this.selectedCert.phoneNumber,
    //   serialNumber: this.selectedCert.serialNumber
    // }
    // if (isSuccess) {
    //   this.isCallDone = true;
    //   this.signDocumentService.signDone(data).subscribe(res => {
    //     if (res && res.data) {
    //       this.onSignSuccess();
    //     } else {
    //       this.isCallDone = false;
    //     }
    //   },
    //     err => {
    //       this.errorStatus = this.message.getMessage('messages.sign_fail');
    //     })
    //   // const res = await this.signDocumentService.signDone(data).toPromise();
    //   // if (res && res.data) {
    //   //   this.onSignSuccess();
    //   // } else {
    //   //   this.isCallDone = false;
    //   // }
    // } else {
    //   this.errorStatus = "messages.stop_sign_document";
    //   this.signDocumentService.signCancel(data).subscribe(res => {
    //     // this.errorStatus = "messages.stop_sign_document";
    //   });
    // }
  }

  private async processSignServerNoImage() {
    let isSuccess = true;
    const filePath = {};
    const mainContractAttachmentsNew = [];
    for await (const img of this.signProcessing) {
      if (this.isCancel) {
        isSuccess = false;
        break;
      }
      const sign = JSON.parse(JSON.stringify(this.sign));
      sign.position = img;
      const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === img.fileId);
      sign.path = file && file.path ? file.path : null;
      sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : '';
      const res = await this.signDocumentService.signatureServerNoImage(sign).toPromise().catch(err => {
        this.errorStatus = this.message.getMessage('messages.sign_fail');
      });
      ;
      if (res && !res.success) {
        isSuccess = false;
        this.signError = res && res.message ? res.message : null;
        break;
      }
      if (!res || !res.data) {
        isSuccess = false;
        break;
      } else {
        filePath[img.fileId] = res.data.path;
        const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
        if (!contractAttachment) {
          const contractAttachmentNew = JSON.parse(JSON.stringify(file));
          contractAttachmentNew.path = res.data.path;
          mainContractAttachmentsNew.push(contractAttachmentNew);
        } else {
          contractAttachment.path = res.data.path;
        }
        if (!this.isCancel) {
          img.done = true;
        }
      }
    }
    if (this.isCancel) {
      isSuccess = false;
    }
    const data = {
      signTransactionId: this.signTransactionId,
      userCancel: this.userCancel,
      signMethod: this.selectedCert.typeCertificate,
      contractId: this.document.id,
      mainContractAttachments: mainContractAttachmentsNew,
      certificate: this.sign.certificate,
      digitalCertificateDetailId: this.selectedCert.idDetail,
      digitalCertificateId: this.selectedCert.id,
      message: this.messageSign

    }
    if (isSuccess) {
      this.isCallDone = true;
      this.signDocumentService.signDone(data).subscribe(res => {
          if (res && res.data) {
            this.onSignSuccess();
          } else {
            this.isCallDone = false;
          }
        },
        err => {
          this.errorStatus = this.message.getMessage('messages.sign_fail');
        })
      // const res = await this.signDocumentService.signDone(data).toPromise();
      // if (res && res.data) {
      //   this.onSignSuccess();
      // } else {
      //   this.isCallDone = false;
      // }
    } else {
      this.errorStatus = "messages.stop_sign_document";
      this.signDocumentService.signCancel(data).subscribe(res => {
        // this.errorStatus = "messages.stop_sign_document";
      });
    }
  }

  onClickConfirmButton() {
    setTimeout(() => {
      if (this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT) {
        if (this.isShowEKYC && this.current === 2) {
          this.onNextEKYC()
        } else this.processSignNoCertificate();
      } else {
        switch (this.selectedCert.typeCertificate) {
          case this.signMethod.SIGN_SERVER:
            this.processSignServerNoImage();
            break;
          case this.signMethod.SIGN_USB_TOKEN:
            // this.blockUI.start('');
            this.isCallDone = true;
            initPluginCertificateNormal(this, null);
            break;
          case this.signMethod.SIGN_SIM_CA:
            this.processSignSimCANoImage();
            break;
          case this.signMethod.SIGN_OTP:
            if (this.isShowEKYC && this.current === 2) {
              this.onNextEKYC()
            } else {
              this.processSignOTP()
            }
            ;
            break;
          case this.SIGN_HSM:
            this.processSignHSM();
            break;
          case EnumSignMethod.CLOUD_CA:
            this.isCallDone = false;
            this.processSignCloudCA();
            break;
          case this.signMethod.SIGN_EKYC:
          case this.signMethod.SIGN_EKYC_ADVANCED:
            this.onNextEKYC();
            break;
          default:
            break;
        }
      }
    }, 400);
  }

  private onNextEKYC(): void {
    this.next();
  }

  async createHashSvc(certUserBase64: string) {
    if (this.sign !== null) {
      this.sign.certificate = certUserBase64;
      if (this.fileUpload) {
        if (this.imageData.length || !this.isShowImage) {
          const filePath = {};
          let isSuccess = true;
          const mainContractAttachmentsNew = [];
          for await (let [index, img] of this.signProcessing.entries()) {
            if (this.isCancel) {
              isSuccess = false;
              break;
            }
            const sign = JSON.parse(JSON.stringify(this.sign));
            sign.position = JSON.stringify(img);

            sign.image = this.fileUpload;
            const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === img.fileId);
            sign.path = file && file.path ? file.path : null;
            sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : '';
            const rs = await this.documentService.createHashWithImageBase64(sign);
            if (rs && !rs.success) {
              isSuccess = false;
              this.signError = rs && rs.message ? rs.message : null;
              break;
            }
            if (rs && rs.data) {
              filePath[img.fileId] = rs.data.path;
              const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
              if (!contractAttachment) {
                const contractAttachmentNew = JSON.parse(JSON.stringify(file));
                contractAttachmentNew.path = rs.data.path;
                mainContractAttachmentsNew.push(contractAttachmentNew);
              } else {
                contractAttachment.path = rs.data.path;
              }
              delete sign.oldPath;
              sign.path = rs.data.path;
              sign.signPdf = rs.data.signPdf;
              const signature = await signHashNormal(this, rs.data.hash, this.sessionId, this.sign.serialNumber);
              if (signature) {
                if (index === 0) {
                  this.isCallDone = false;
                }
                sign.position = JSON.parse(sign.position);
                sign.signPositions = this.signImages;
                const resSign = await this.signUsbNormal(signature, sign);
                if (resSign && !resSign.success) {
                  isSuccess = false;
                  this.signError = resSign && resSign.message ? resSign.message : null;
                  break;
                }
                if (!resSign || !resSign.data) {
                  isSuccess = false;
                  break;
                }
                img.done = true;
              } else {
                isSuccess = false;
                break;
              }
            } else {
              isSuccess = false;
              break;
            }
          }
          if (this.isCancel) {
            isSuccess = false;
          }
          const data = {
            signTransactionId: this.signTransactionId,
            userCancel: this.userCancel,
            signMethod: this.selectedCert.typeCertificate,
            contractId: this.document.id,
            mainContractAttachments: mainContractAttachmentsNew,
            certificate: this.sign.certificate,
            digitalCertificateDetailId: this.selectedCert.idDetail,
            message: this.messageSign
          }
          if (isSuccess) {
            this.isCallDone = true;
            this.signDocumentService.signDone(data).subscribe(res => {
                if (res && res.data) {
                  this.onSignSuccess();
                } else {
                  this.isCallDone = false;
                }
              },
              err => {
                this.errorStatus = this.message.getMessage('messages.sign_fail');
              })
            // const res = await this.signDocumentService.signDone(data).toPromise();
            // if (res && res.data) {
            //   this.onSignSuccess();
            // } else {
            //   this.isCallDone = false;
            // }
          } else {
            this.errorStatus = "messages.stop_sign_document";
            this.signDocumentService.signCancel(data).subscribe(res => {
              // this.errorStatus = "messages.stop_sign_document";
            });
          }
        }
        // this.documentService.createHashWithImage(this.sign).subscribe(rs => {
        //   this.sign.path = rs.data.path;
        //   this.sign.signPdf = rs.data.signPdf;
        // this.sign.signature = signHash(this, rs.data.hash);
        // signHashNormal(this, rs.data.hash, this.sessionId, this.sign.serialNumber);
        // this.sign.signature = signHashNormal(this, rs.data.hash, this.sessionId, this.sign.serialNumber);
        // if (this.sign.signature) {
        //   this.signUsb(this.sign);
        // }
        // });
      } else {
        const filePath = {};
        let isSuccess = true;
        const mainContractAttachmentsNew = [];
        for await (let [index, img] of this.signProcessing.entries()) {
          if (this.isCancel) {
            isSuccess = false;
            break;
          }
          const sign = JSON.parse(JSON.stringify(this.sign));
          sign.position = img;

          const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === img.fileId);
          sign.path = file && file.path ? file.path : null;
          sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : '';
          const rs = await this.documentService.createHashNoImage(sign).toPromise();
          if (rs && !rs.success) {
            isSuccess = false;
            this.signError = rs && rs.message ? rs.message : null;
            break;
          }
          if (rs && rs.data) {
            filePath[img.fileId] = rs.data.path;
            const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
            if (!contractAttachment) {
              const contractAttachmentNew = JSON.parse(JSON.stringify(file));
              contractAttachmentNew.path = rs.data.path;
              mainContractAttachmentsNew.push(contractAttachmentNew);
            } else {
              contractAttachment.path = rs.data.path;
            }
            delete sign.oldPath;
            sign.path = rs.data.path;
            sign.signPdf = rs.data.signPdf;
            const signature = await signHashNormal(this, rs.data.hash, this.sessionId, this.sign.serialNumber);
            if (signature) {
              if (index === 0) {
                this.isCallDone = false;
              }
              sign.signPositions = this.signImages;
              const resSign = await this.signUsbNormal(signature, sign);
              if (resSign && !resSign.success) {
                isSuccess = false;
                this.signError = resSign && resSign.message ? resSign.message : null;
                break;
              }
              if (!resSign || !resSign.data) {
                isSuccess = false;
                break;
              }
              img.done = true;
            } else {
              isSuccess = false;
              break;
            }
          } else {
            isSuccess = false;
            break;
          }
        }
        if (this.isCancel) {
          isSuccess = false;
        }
        const data = {
          signTransactionId: this.signTransactionId,
          userCancel: this.userCancel,
          signMethod: this.selectedCert.typeCertificate,
          contractId: this.document.id,
          mainContractAttachments: mainContractAttachmentsNew,
          certificate: this.sign.certificate,
          digitalCertificateDetailId: this.selectedCert.idDetail,
          message: this.messageSign
        }
        if (isSuccess) {
          this.isCallDone = true;
          this.signDocumentService.signDone(data).subscribe(res => {
              if (res && res.data) {
                this.onSignSuccess();
              } else {
                this.isCallDone = false;
              }
            },
            err => {
              this.errorStatus = this.message.getMessage('messages.sign_fail');
            })
          // const res = await this.signDocumentService.signDone(data).toPromise();
          // if (res && res.data) {
          //   this.onSignSuccess();
          // } else {
          //   this.isCallDone = false;
          // }
        } else {
          this.errorStatus = "messages.stop_sign_document";
          this.signDocumentService.signCancel(data).subscribe(res => {
            // this.errorStatus = "messages.stop_sign_document";
          });
        }
        // this.documentService.createHashNoImage(this.sign).subscribe(rs => {
        //   this.sign.path = rs.data.path;
        //   this.sign.signPdf = rs.data.signPdf;
        // });
      }
    }
  }

  async createHash(certUserBase64: string) {
    if (this.sign !== null) {
      this.sign.certificate = certUserBase64;
      if (this.fileUpload) {
        if (this.imageData.length || !this.isShowImage) {
          const filePath = {};
          let isSuccess = true;
          const mainContractAttachmentsNew = [];
          const fileArr = new Set(this.signProcessing.map($ => $.fileId))
          for await (let [idx, fileId] of fileArr.entries()) {
            if (this.isCancel) {
              isSuccess = false;
              break;
            }
            const sign = JSON.parse(JSON.stringify(this.sign));
            const _dst$ = this.signProcessing.filter($ => $.fileId == fileId);
            sign.position = JSON.stringify(_dst$[0]);
            sign.signPositions = _dst$;

            sign.image = this.fileUpload;
            const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === fileId);
            sign.path = file && file.path ? file.path : null;
            sign.oldPath = filePath[fileId] ? filePath[fileId] : '';
            const rs = await this.documentService.createHashWithImageBase64(sign);
            if (rs && !rs.success) {
              isSuccess = false;
              this.signError = rs && rs.message ? rs.message : null;
              break;
            }
            if (rs && rs.data) {
              filePath[fileId] = rs.data.path;
              const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
              if (!contractAttachment) {
                const contractAttachmentNew = JSON.parse(JSON.stringify(file));
                contractAttachmentNew.path = rs.data.path;
                mainContractAttachmentsNew.push(contractAttachmentNew);
              } else {
                contractAttachment.path = rs.data.path;
              }
              delete sign.oldPath;
              sign.path = rs.data.path;
              sign.signPdf = rs.data.signPdf;
              const signature = await signHashNormal(this, rs.data.hash, this.sessionId, this.sign.serialNumber);
              if (signature) {
                if (idx === 0) {
                  this.isCallDone = false;
                }
                sign.position = JSON.parse(sign.position);
                sign.signPositions = this.signImages;
                const resSign = await this.signUsbNormal(signature, sign);
                if (resSign && !resSign.success) {
                  isSuccess = false;
                  this.signError = resSign && resSign.message ? resSign.message : null;
                  break;
                }
                if (!resSign || !resSign.data) {
                  isSuccess = false;
                  break;
                }
                _dst$.forEach($ => $.done = true);
              } else {
                isSuccess = false;
                break;
              }
            } else {
              isSuccess = false;
              break;
            }
          }
          if (this.isCancel) {
            isSuccess = false;
          }
          const data = {
            signTransactionId: this.signTransactionId,
            userCancel: this.userCancel,
            signMethod: this.selectedCert.typeCertificate,
            contractId: this.document.id,
            mainContractAttachments: mainContractAttachmentsNew,
            certificate: this.sign.certificate,
            digitalCertificateDetailId: this.selectedCert.idDetail,
            message: this.messageSign
          }
          if (isSuccess) {
            this.isCallDone = true;
            this.signDocumentService.signDone(data).subscribe(res => {
                if (res && res.data) {
                  this.onSignSuccess();
                } else {
                  this.isCallDone = false;
                }
              },
              err => {
                this.errorStatus = this.message.getMessage('messages.sign_fail');
              })
            // const res = await this.signDocumentService.signDone(data).toPromise();
            // if (res && res.data) {
            //   this.onSignSuccess();
            // } else {
            //   this.isCallDone = false;
            // }
          } else {
            this.errorStatus = "messages.stop_sign_document";
            this.signDocumentService.signCancel(data).subscribe(res => {
              // this.errorStatus = "messages.stop_sign_document";
            });
          }
        }
        // this.documentService.createHashWithImage(this.sign).subscribe(rs => {
        //   this.sign.path = rs.data.path;
        //   this.sign.signPdf = rs.data.signPdf;
        // this.sign.signature = signHash(this, rs.data.hash);
        // signHashNormal(this, rs.data.hash, this.sessionId, this.sign.serialNumber);
        // this.sign.signature = signHashNormal(this, rs.data.hash, this.sessionId, this.sign.serialNumber);
        // if (this.sign.signature) {
        //   this.signUsb(this.sign);
        // }
        // });
      } else {
        const filePath = {};
        let isSuccess = true;
        const mainContractAttachmentsNew = [];
        if (this.signProcessing && this.signProcessing.length > 0) {
          const fileArr = new Set(this.signProcessing.map($ => $.gileId));
          for await (const [idx, fileId] of fileArr.entries()) {
            if (this.isCancel) {
              isSuccess = false;
              break;
            }
            const sign = JSON.parse(JSON.stringify(this.sign));
            const _dst$ = this.signProcessing.filter($ => $.fileId == fileId);
            sign.position = _dst$[0];
            sign.signPositions = _dst$;

            const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === fileId);
            sign.path = file && file.path ? file.path : null;
            sign.oldPath = filePath[fileId] ? filePath[fileId] : '';
            const rs = await this.documentService.createHashNoImage(sign).toPromise();
            if (rs && !rs.success) {
              isSuccess = false;
              this.signError = rs && rs.message ? rs.message : null;
              break;
            }
            if (rs && rs.data) {
              filePath[fileId] = rs.data.path;
              const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
              if (!contractAttachment) {
                const contractAttachmentNew = JSON.parse(JSON.stringify(file));
                contractAttachmentNew.path = rs.data.path;
                mainContractAttachmentsNew.push(contractAttachmentNew);
              } else {
                contractAttachment.path = rs.data.path;
              }
              delete sign.oldPath;
              sign.path = rs.data.path;
              sign.signPdf = rs.data.signPdf;
              const signature = await signHashNormal(this, rs.data.hash, this.sessionId, this.sign.serialNumber);
              if (signature) {
                if (idx === 0) {
                  this.isCallDone = false;
                }
                sign.signPositions = this.signImages;
                const resSign = await this.signUsbNormal(signature, sign);
                if (resSign && !resSign.success) {
                  isSuccess = false;
                  this.signError = resSign && resSign.message ? resSign.message : null;
                  break;
                }
                if (!resSign || !resSign.data) {
                  isSuccess = false;
                  break;
                }
                _dst$.forEach($ => $.done = true);
              } else {
                isSuccess = false;
                break;
              }
            } else {
              isSuccess = false;
              break;
            }
          }
        }

        if (this.isCancel) {
          isSuccess = false;
        }
        const data = {
          signTransactionId: this.signTransactionId,
          userCancel: this.userCancel,
          signMethod: this.selectedCert.typeCertificate,
          contractId: this.document.id,
          mainContractAttachments: mainContractAttachmentsNew,
          certificate: this.sign.certificate,
          digitalCertificateDetailId: this.selectedCert.idDetail,
          message: this.messageSign
        }
        if (isSuccess) {
          this.isCallDone = true;
          this.signDocumentService.signDone(data).subscribe(res => {
              if (res && res.data) {
                this.onSignSuccess();
              } else {
                this.isCallDone = false;
              }
            },
            err => {
              this.errorStatus = this.message.getMessage('messages.sign_fail');
            })
          // const res = await this.signDocumentService.signDone(data).toPromise();
          // if (res && res.data) {
          //   this.onSignSuccess();
          // } else {
          //   this.isCallDone = false;
          // }
        } else {
          this.errorStatus = "messages.stop_sign_document";
          this.signDocumentService.signCancel(data).subscribe(res => {
            // this.errorStatus = "messages.stop_sign_document";
          });
        }
        // this.documentService.createHashNoImage(this.sign).subscribe(rs => {
        //   this.sign.path = rs.data.path;
        //   this.sign.signPdf = rs.data.signPdf;
        // });
      }
    }
  }

  createHashWorker(certUserBase64: string, hSession: string, serialNumber: string) {
    if (this.sign !== null) {
      this.sign.certificate = certUserBase64;
      if (this.fileUpload) {
        this.documentService.createHashWithImageBase64(this.sign).then(async rs => {
          this.sign.path = rs.data.path;
          this.sign.signPdf = rs.data.signPdf;
          this.subscribeHash.next(rs.data.hash);
          // await this.usbTokenService.workerSignHash(this, rs.data.hash, hSession, serialNumber);
        });
      } else {
        this.documentService.createHashNoImage(this.sign).subscribe(async rs => {
          this.sign.path = rs.data.path;
          this.sign.signPdf = rs.data.signPdf;
          this.subscribeHash.next(rs.data.hash);
          // await this.usbTokenService.workerSignHash(this, rs.data.hash, hSession, serialNumber);
        });
      }
    }
  }

  async signUsbNormal(signature: string, sign: any) {
    sign.signature = signature;
    const res = await this.signUsb(sign);
    return res;
  }

  async signUsb(certificate: any) {
    const res = await this.documentService.signUsb(certificate).toPromise();
    return res;
  }

  onClickConfirmButtonImage() {
    setTimeout(() => {
      if (this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT) {
        if (this.isShowEKYC && this.current === 2) {
          this.onNextEKYC()
        } else this.processSignNoCertificate();
      } else {
        switch (this.selectedCert.typeCertificate) {
          case this.signMethod.SIGN_SERVER:
            this.processSignServerImage();
            break;
          case this.signMethod.SIGN_USB_TOKEN:
            // this.blockUI.start('');
            this.isCallDone = true;
            initPluginCertificateNormal(this, null);
            break;
          case this.signMethod.SIGN_SIM_CA:
            this.processSignSimCAImage();
            break;
          case this.signMethod.SIGN_OTP:
            if (this.isShowEKYC && this.current === 2) {
              this.onNextEKYC()
            } else {
              // this.processSignOTP()
            }
            ;
            break;
          case this.selectedCert.typeCertificate === this.SIGN_HSM:
            this.processSignHSM();
            break;
          case this.signMethod.SIGN_EKYC:
          case this.signMethod.SIGN_EKYC_ADVANCED:
            this.onNextEKYC();
            break;
          case EnumSignMethod.CLOUD_CA:
            this.isCallDone = false;
            this.processSignCloudCA();
            break;
          default:
            break;
        }
      }
    }, 400);
  }


  openDialogConfirmSignOTP(transactionId: string) {
    let signMethod = this.selectedCert.typeCertificate;
    if (this.isShowEKYC) {
      if (this.ekycSupportConfig === 1) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC;
      } else if (this.ekycSupportConfig === 2) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC_ADVANCED;
      }
    }
    let request = {
      signMethod: signMethod,
      signPositions: this.signImages
    }

    const dataCancel = {
      transactionId: transactionId,
      userCancel: true,
      signMethod: this.selectedCert.typeCertificate,
      contractId: this.document.id,
      mainContractAttachments: [],
      certificate: this.sign.certificate,
      digitalCertificateDetailId: this.selectedCert.idDetail,
      phoneNumber: this.selectedCert.phoneNumber,
      serialNumber: this.selectedCert.serialNumber
    }
    this.dialogRef = this.dialog.open(ConfirmSignOtpWithImageComponent, {
      width: '40%',
      data: {
        documentId: this.sign.contractId,
        transaction: transactionId,
        selectedPhone: this.selectedCert.phoneNumber,
        listSignPosition: this.imageData,
        image: this.fileUpload,
        function: this.processSignOTPAfterDialogClose.bind(this),
        supportEkyc: this.supportEkyc,
        request: request,
        signingInteval: this.signingInteval,
        openSigningDialog: this.openSigningDialog,
        dataCancel: dataCancel
      }
    });

    this.dialogRef.afterClosed().subscribe((ref) => {
      if (ref) {
        this.dialogRef = this.dialog.open(SigningDialogComponent, {
          width: '80%',
          disableClose: true,
          data: this
        });
        this.dialogRef.afterClosed().subscribe(() => {
          this.signProcessing = [];
          this.errorStatus = null;
          this.signError = null;
          this.isCancel = false;
          this.isCallDone = false;
          this.processingId = null;
          this.dialog.closeAll();
        });
      }

    });
  }

  private onSignSuccess() {
    this.dialog.closeAll();
    if (this.isSignDigitalCertificate) {
      this.toastr.success(this.message.getMessage('messages.approve_success'));
    } else {
      this.toastr.success(this.message.getMessage('messages.sign_success'));
    }

    if (this.systemImageSign && this.fileUpload && this.signConfig) {
      this.signDocumentService.postUserConfigAsync(this.signConfig).subscribe();
    }
    this.success = true;
    // this.router.navigate([`/home-enterprise/view-document/${this.contractId}`], {});
    // this.navigation.g
    // this.dialogRef.close();
    this.blockUI.stop();
    this.backToPrePage();
  }

  backToPrePage() {
    this.router.navigate([this.routeLink], {
      queryParams: {
        flagCopy: true,
        page: this.page,
        pageSize: this.pageSize,
        routeLink: this.routeLink,
        enterprise: this.enterprise,
        documentType: this.documentTypeSearch,
        nameOrCode: this.nameOrCode,
        customerName: this.customerName,
        status: this.status,
        serviceType: this.serviceType,
        taxCode: this.taxCode,
        createdUser: this.createdUser,
        createdTimeFrom: this.createdTimeFrom,
        createdTimeTo: this.createdTimeTo,
        finishDateFrom: this.finishDateFrom,
        finishDateTo: this.finishDateTo,
        pageView: true,
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection
      }
    });
  }

  async onClickSignButton() {
    // this.isClickSignBuuton = true;
    // if (this.isSelectPosition) {
    //   this.toastr.error(this.message.getMessage('messages.need_choose_position'));
    //   return;
    // }

    // // kiem tra file da ky day du chua
    // if (this.document.mainContractAttachments && this.document.mainContractAttachments.length) {

    //   const fileName = [];
    //   let indexError = null;
    //   let filePathError = null;
    //   const fileError = [];
    //   this.document.mainContractAttachments.forEach((ca, index) => {
    //     const fileId = this.decodeId(ca.id);
    //     const sign = this.signPosition.filter(sign => {
    //       return sign.fileId === fileId;
    //     });
    //     if (!sign.length) {
    //       if (!indexError) {
    //         indexError = index;
    //         filePathError = ca.path
    //       }
    //       fileError.push(ca.id);
    //       fileName.push(`'${ca.fileName}'`);
    //     }
    //   });
    //   if (fileName.length) {
    //     this.changeFile(filePathError, indexError);
    //     this.fileError = fileError;
    //     this.toastr.error(this.commonService.format(this.message.getMessage('messages.need_create_sign_file'), fileName.join(', ')).replace(/&quot;/g, "'"));
    //     return;
    //   }
    // }
    // this.contractSignEntityList = _.cloneDeep(this.imageData);
    // this.sign = {
    //   contractId: this.contractId,
    //   digitalCertificateId: this.selectedCert.id,
    //   digitalCertificateDetailId: this.selectedCert.idDetail,
    //   ...this.selectedCert
    // };
    // let imageSort = [];

    // for (const contractAttachment of this.document.mainContractAttachments) {
    //   const fileId = this.decodeId(contractAttachment.id);
    //   const imageData = this.imageData.filter(item => {
    //     return item.fileId === fileId
    //   });
    //   imageSort = imageSort.concat(imageData);
    // }
    // const imageData = imageSort.filter(item => {
    //   if (item.signType === 'combine') {
    //     item.signType = 'image';
    //   }
    //   return item.signType !== 'digital'
    // });
    // let imageData = []
    // const arr1 = [];
    // for (let i = 0; i < imageSort.length; i++) {
    //   for (let j = 0; j < imageSort.length; j++) {
    //     if (i !== j && imageSort[j].positionX == imageSort[i].positionX
    //       && imageSort[j].positionY == imageSort[i].positionY
    //       && imageSort[j].pageNumber == imageSort[i].pageNumber
    //       && imageSort[j].widthRectangle == imageSort[i].widthRectangle
    //       && imageSort[j].heightRectangle == imageSort[i].heightRectangle
    //       && imageSort[j].zoom == imageSort[i].zoom
    //       && imageSort[j].fileId == imageSort[i].fileId
    //       && imageSort[j].signType !== imageSort[i].signType) {
    //       arr1.push(imageSort[i])
    //       imageSort.splice(j, 1);
    //       imageSort.splice(i, 1);
    //       i--;
    //       break;
    //     }
    //   }
    // }
    // arr1.map(item => item.signType = 'image')
    // imageData = ([...imageSort, ...arr1]);
    // let imagePreSort = [];
    // //sort sign by file - pageNumber - positionY
    // for (const contractAttachment of this.document.mainContractAttachments) {
    //   const fileId = this.decodeId(contractAttachment.id);
    //   let imageList = imageData.filter(item => {
    //     return item.fileId === fileId
    //   });
    //   imageList = imageList.sort((a, b) => a.pageNumber === b.pageNumber ?
    //     Number(b.positionY) - Number(a.positionY) :
    //     Number(a.pageNumber) - Number(b.pageNumber));
    //   imagePreSort = imagePreSort.concat(imageList);
    // }
    if (this.document.isConfirmBCT) {
      this.signImages = this.signImages.map((item) => {
        item['signTransactionId'] = this.signTransactionId;
        return item;
      })
    }
    this.signProcessing = JSON.parse(JSON.stringify(this.signImages));
    setTimeout(() => {
      if (this.selectedCert.typeCertificate !== this.signMethod.SIGN_OTP && this.selectedCert.typeCertificate !== this.signMethod.SIGN_NO_CERT) {
        this.dialogRef = this.dialog.open(SigningDialogComponent, {
          width: '80%',
          disableClose: true,
          data: this
        });
        this.dialogRef.afterClosed().subscribe(() => {
          this.signProcessing = [];
          this.errorStatus = null;
          this.signError = null;
          this.isCancel = false;
          this.isCallDone = false;
          this.processingId = null;
          this.dialog.closeAll();
        });
      }
    }, 0)

    // await this.signUsbToken();
    // if (!this.fileUpload) {
    //   this.onClickConfirmButton();
    // } else {
    //   this.sign = {
    //     ...this.sign,
    //     image: this.fileUpload,
    //   };
    // }

    if (this.fileUpload) {
      this.sign = {
        ...this.sign,
        image: this.fileUpload,
      };
    }

    // if (this.current === 3 && this.isShowEKYC) {
    //   this.onIdentityEKYC();
    //   return;
    // }
    if (!this.isShowImage) {
      fetch('../../../../../../../assets/images/arrowLeft.png')
        .then(response => response.blob())
        .then(blob => {
          // console.log(blob);
          this.fileUpload = new File([blob], 'fileNameGoesHere', {type: 'image/png'});
          this.selectedImage = this.fileUpload;
          if (this.fileUpload) {
            this.onClickConfirmButtonImage();
          }
        })
        .catch(error => {
          console.error('Lỗi khi đọc tệp ảnh', error);
        });
    } else {
      if (!this.fileUpload) {
        this.onClickConfirmButton();
      } else {
        // this.sign = {
        //   ...this.sign,
        //   image: this.fileUpload,
        // };
        this.onClickConfirmButtonImage();
      }
    }
  }

  private onIdentityEKYC() {
    const dataImg = this.ekyc.getDataImage();
    if (!dataImg) return;
    let body = {
      typeImage: dataImg.typeImage,
      contractId: this.sign.contractId,
      images: dataImg.images.map(image => {
        return {base64Image: image.base64Image, type: image.type}
      })
    }
    // if (this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT) {
    //   this.ekycSupportWithoutImageNoCtsMb(body);
    // }
    if (this.selectedCert.typeCertificate === this.signMethod.SIGN_OTP || this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT) {
      this.validateEKYCOtp(body);
    }

    // if (this.selectedCert.typeCertificate === this.signMethod.SIGN_EKYC || this.selectedCert.typeCertificate === this.signMethod.SIGN_EKYC_ADVANCED) {
    //   this.signEkyc(body);
    // }
  }

  private async signEkyc(body) {
    let base64String = null;
    if (this.sign.image) {
      base64String = await this.commonService.getBase64(this.sign.image);
    }

    let input = {
      ...body,
      listSignPosition: JSON.stringify(this.sign.listSignPosition.map(signPosition => {
        return {
          positionY: signPosition.positionY,
          pageNumber: signPosition.pageNumber,
          zoom: signPosition.zoom,
          positionX: signPosition.positionX,
          widthRectangle: signPosition.widthRectangle,
          heightRectangle: signPosition.heightRectangle,
          signType: signPosition.signType,
        }
      })),
      base64Image: base64String ? String(base64String).split(",")[1] : null,
      base64ImageFileName: base64String ? this.sign.image.name : null
    };
    this.blockUI.start('');
    this.signDocumentService.verifyEkyc(input)
      .subscribe(res => {
        if (res && res.success) {
          this.onSignSuccess();
        } else {
          if (res && !res.success) {
            this.toastr.error(this.message.getMessage(res.message));
            this.blockUI.stop();
            return;
          }
        }
      })
  }

  private async ekycSupportWithoutImageNoCtsMb(body) {
    const base64String = await this.commonService.getBase64(this.sign.image);
    let input = {
      ...body,
      listSignPosition: JSON.stringify(this.sign.listSignPosition.map(signPosition => {
        return {
          positionY: signPosition.positionY,
          pageNumber: signPosition.pageNumber,
          zoom: signPosition.zoom,
          positionX: signPosition.positionX,
          widthRectangle: signPosition.widthRectangle,
          heightRectangle: signPosition.heightRectangle,
          signType: signPosition.signType,
        }
      })),
      base64Image: String(base64String).split(",")[1],
      // base64Image: base64String,
      base64ImageFileName: this.sign.image.name
    }
    this.blockUI.start('');
    this.signDocumentService.ekycSupportWithoutImageNoCtsMb(input)
      .subscribe(res => {
        if (res && res.success) {
          this.onSignSuccess();
        } else {
          if (res && !res.success) {
            this.blockUI.stop();
            // this.toastr.error(this.message.getMessage(res.message));
            let dialogRef;
            if (res.code === "0x002413")
              dialogRef = this.dialog.open(ConfirmResignEkycSupportComponent, {
                width: '350px',
                data: {message: this.message.getMessage('messages.sign_fail_ekyc'),}
              });
            else
              dialogRef = this.dialog.open(ConfirmResignEkycSupportComponent, {
                width: '350px',
                data: {message: this.message.getMessage('messages.confirm_resign_ekyc'),}
              });
            dialogRef.afterClosed().subscribe(rs => {
              // console.log(rs)
              if (rs) {
                this.isReloadCamera = true;
                setTimeout(x => {
                  this.isReloadCamera = false;
                }, 300);
              } else {
                this.router.navigate([`/home-enterprise/view-document/${this.contractId}`], {});
              }
            })
          }
        }
      })
  }

  private validateEKYCOtp(body: any): void {
    this.blockUI.start('');
    this.signDocumentService.valiadateEkycOtpSupport(body)
      .subscribe(res => {
        this.blockUI.stop();
        if (res && res.success) {
          if (this.selectedCert.typeCertificate === this.signMethod.SIGN_OTP) {
            this.processSignOTP();
          } else if (this.selectedCert.typeCertificate === this.signMethod.SIGN_NO_CERT) {
            this.processSignNoCertificate();
          }
        } else {
          if (res && !res.success) {
            // this.toastr.error(this.message.getMessage(res.message));
            let dialogRef;
            if (res.code === "0x002413")
              dialogRef = this.dialog.open(ConfirmResignEkycSupportComponent, {
                width: '350px',
                data: {message: this.message.getMessage('messages.sign_fail_ekyc'),}
              });
            else
              dialogRef = this.dialog.open(ConfirmResignEkycSupportComponent, {
                width: '350px',
                data: {message: this.message.getMessage('messages.confirm_resign_ekyc'),}
              });
            dialogRef.afterClosed().subscribe(rs => {
              // console.log(rs)
              if (rs) {
                this.isReloadCamera = true;
                setTimeout(x => {
                  this.isReloadCamera = false;
                }, 300);
              } else {
                this.router.navigate([`/home-enterprise/view-document/${this.contractId}`], {});
              }
            })
          }
        }
      })
  }

  onSelectImageSignMethod(type: number) {
    if (this.isCertificateSupport && this.supportEkyc) {
      this.isReloadCamera = false;
    }
  }

  onChangeSubType(cert: any) {
    if ((cert.typeCertificate === this.signMethod.SIGN_OTP || cert.typeCertificate === this.signMethod.SIGN_NO_CERT) && this.isCertificateSupport && this.supportEkyc) {
      this.isReloadCamera = false;
    } else {
      this.isReloadCamera = true;
    }
    this.checkConnectPlugis(cert);
  }

  checkConnectPlugis(cert) {
  }

  onClickBtnCancel() {
    this.backToPrePage();
  }

  /*
  Xử lý gọi hàm từ các nút trên mobile
  */
  onClickCallFunction(idFunction: any) {
    switch (idFunction) {
      case 1:
        // Hủy bỏ
        this.onClickBtnCancel();
        break;
      case 2:
        // Quay lại
        this.pre();
        break;
      case 3:
        // Tiếp thep
        this.next();
        break;
      case 4:
        // Chuyển đến trang ký
        this.gotoSignPage();
        break;
      case 5:
        // Chọn lại vị trí
        this.onStamped();
        break;
      case 6:
        // Ký
        this.checkTimestampMoney();
        break;
      default:
        break;
    }
  }

  createATag(link: string, title: string) {
    return '<a target="_blank" href="' + link + '">' + title + '</a>';
  }


  showErrMsgTransleFormat(msg) {
    const link = this.linkDownSignPlugin();

    this.dialog.open(AlertComponent, {
      width: '370px',
      data: this.message.getMessage(msg)
        + this.createATag(this.linkDownSignPlugin('WINDOWS'), 'Windows, ') + this.createATag(this.linkDownSignPlugin('MACOS'), 'MacOS, ') + this.createATag(this.linkDownSignPlugin('LINUX'), 'ViettelOS')
      // + '<a target="_blank" href="' + link + '"><b> ' + this.message.getMessage('messages.here') + '</b></a>'
      //     + '<br/ >' + this.message.getMessage('messages.download_plugin_sign_os') + this.createATag(this.linkDownSignPlugin('WINDOWS'), 'Windows, ') + this.createATag(this.linkDownSignPlugin('MACOS'), 'MacOS, ') + this.createATag(this.linkDownSignPlugin('LINUX'), 'ViettelOS')
    });
  }

  nzSelectChange(index = 0) {
    // Invalidate all pending async operations and abort in-flight fetch
    this.activeTabGenerationId++;
    if (this.activeAbortCtrl) {
      this.activeAbortCtrl.abort();
      this.activeAbortCtrl = null;
    }
    let isShowDefaultTab = this.selectedCert.typeCertificate !== this.signMethod.SIGN_NO_CERT && this.selectedCert.imageUrl;
    const indexSystemTab = isShowDefaultTab ? 1 : 0;
    const indexUploadTab = isShowDefaultTab ? 2 : 1;
    const indexDrawTab = isShowDefaultTab ? 3 : 2;
    this.indexSelect = index;
    if (this.selectedCert.typeCertificate !== this.signMethod.SIGN_NO_CERT) {
      if (index === indexDrawTab) {
        this.isSelectDrawImage = true;
        this.isRenderImage = false;
        this.isDisableNextButton = true;
        this.canvasService.setIsDisableBtnDeleteCanvas(true);
        this.canvasService.setIsApplyDrawSignature(false);
        this.systemImageSign = false;
      }
      if (index === indexUploadTab) {
        this.isSelectDrawImage = false;
        this.isRenderImage = false;
        this.isDisableNextButton = true;
        this.fileUpload = null;
        this.avatarUrl = null;
        this.systemImageSign = false;
      }
      if (index === indexSystemTab) {
        this.systemImageSign = true;
        this.isSelectDrawImage = false;
        this.isRenderImage = false;
        this.isDisableNextButton = false;
        this.fileUpload = null;
        this.avatarUrl = null;
        this.imageUrlPreview = '';
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      }

      if (index === 0 && isShowDefaultTab) {
        this.isSelectDrawImage = false;
        this.isDisableNextButton = false;
        this.fileUpload = null;
        this.systemImageSign = false;
        this.imageUrlPreview = null;
        if (this.selectedCert.imageUrl) {
          // @ts-ignore
          const abortCtrl = new AbortController();
          this.activeAbortCtrl = abortCtrl;
          const generationId = this.activeTabGenerationId;
          fetch(this.selectedCert.imageUrl, { signal: abortCtrl.signal })
            .then(r => r.blob())
            .then(blobFile => {
              if (generationId !== this.activeTabGenerationId) return;
              if (abortCtrl.signal.aborted) return;
              // console.log('selectedCert', blobFile)
              this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
              this.selectedImage = this.fileUpload;
            });
        }
      }
    } else {
      if (index === indexUploadTab) {
        this.isSelectDrawImage = true;
        this.isDisableNextButton = true;
        this.systemImageSign = false;
        this.canvasService.setIsDisableBtnDeleteCanvas(true);
      }

      if (index === indexSystemTab) {
        this.systemImageSign = true;
        this.isSelectDrawImage = false;
        this.isRenderImage = false;
        this.isDisableNextButton = false;
        this.fileUpload = null;
        this.avatarUrl = null;
        this.imageUrlPreview = '';
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      }

      if (index === 0 && isShowDefaultTab) {
        this.isSelectDrawImage = false;
        this.systemImageSign = false;
        this.isDisableNextButton = true;
        this.fileUpload = null;
        this.avatarUrl = null;
      }
    }
  }

  showErrMsgTransle(msg) {
    if (msg === 'messages.not_initPlugin') {
      const link = this.linkDownSignPlugin();
      // if(msg === "messages.not_initPlugin"){
      msg = "messages.initPlugin_faile"
      // }

      this.signError = this.message.getMessage(msg)
        // + '<a target="_blank" href="' + link + '"><b> ' + this.message.getMessage('messages.here') + '</b></a>';
        // + '<a target="_blank" href="' + link + '"><b> ' + this.message.getMessage('messages.here') + '</b></a>';
        + this.createATag(this.linkDownSignPlugin('WINDOWS'), 'Windows, ') + this.createATag(this.linkDownSignPlugin('MACOS'), 'MacOS, ') + this.createATag(this.linkDownSignPlugin('LINUX'), 'ViettelOS');
      //sign cancel
      this.isCancel = true;
      this.documentService.setCancelFlow(true);
      const data = {
        signTransactionId: this.signTransactionId,
        userCancel: this.userCancel,
        signMethod: this.selectedCert.typeCertificate,
        contractId: this.document.id,
        mainContractAttachments: [],
        certificate: this.sign.certificate,
        digitalCertificateDetailId: this.selectedCert.idDetail
      };
      this.errorStatus = "messages.stop_sign_document";
      this.userCancel = false
      this.signDocumentService.signCancel(data).subscribe(res => {
      });
    } else {
      // this.blockUI.stop();
      this.errorStatus = msg;
    }
  }

  showErrorDialog(msg) {
    // this.blockUI.stop();
    this.toastr.error(this.message.getMessage(msg));
  }

  showErrMsg(msg) {
    this.toastr.error(msg);
  }

  setSerialNumber(value) {
    this.sign.serialNumber = value;
  }

  setIssuedTo(value) {
    this.sign.issuedTo = value;
  }

  setDistinguishedName(value) {
    this.sign.distinguishedName = value;
  }

  setTaxCode(value) {
    this.sign.taxCode = value;
  }

  setIssuedBy(value) {
    this.sign.issuedBy = value;
  }

  setCertRawdata(value) {
    this.sign.certRawdata = value;
  }

  setActiveDate(value) {
    this.sign.activeDate = new Date(value);
  }

  setExpireDate(value) {
    this.sign.expireDate = new Date(value);
  }

  setActiveContinueButton() {
    this.isDisableNextButton = false;
  }

  setSessionId(value) {
    this.sessionId = value;
  }

  pdfLoaded() {
  }

  async signFlowDocumentWithCerDefault() {
    // if (this.countAllApiBeforeCertificateDefault > 1 && this.sertificateDefaultOnj !== null && this.sertificateDefaultOnj !== undefined) {\
    if (this.sertificateDefaultOnj !== null && this.sertificateDefaultOnj !== undefined) {
      if (this.sertificateDefaultOnj.imageUrl !== '') {
        const abortCtrl = new AbortController();
        this.activeAbortCtrl = abortCtrl;
        const generationId = this.activeTabGenerationId;
        fetch(this.sertificateDefaultOnj.imageUrl, { signal: abortCtrl.signal })
          .then(r => r.blob())
          .then(blobFile => {
            if (generationId !== this.activeTabGenerationId) return;
            if (abortCtrl.signal.aborted) return;
            this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
            if (this.fileUpload) {
              this.handlePreviewFromFileUpload(this.fileUpload, null);
            }
          });
      } else {
        /**
         * neu khong co anh upload len thi lay anh mac dinh cua he thong cau hinh san
         */
        // debugger;
        const generationId = this.activeTabGenerationId;
        this.signConfig.enterpriseName.value = this.sertificateDefaultOnj.issuedTo || this.sertificateDefaultOnj.certificateName || '';
        this.signConfig.email.value = this.sertificateDefaultOnj.email || '';
        let imageSize = this.setSizeFrameImage();
        let blob = null;
        try {
          blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();

        } catch (e) {
          try {
            let imageSize = this.setSizeFrameImage();
            blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
          } catch (e) {
            console.log("call api error, use html to image", e);
          }
        }

        // Skip if tab changed while waiting for response
        if (generationId !== this.activeTabGenerationId) return;

        if(!blob){
          this.toastr.error(this.message.getMessage('messages.error_proccessing'));
          return;
        }
        const file = new File([blob], 'test.png', {type: 'image/png'});
        this.fileUpload = file;
        this.systemImageSign = true;
        if (this.fileUpload) {

          this.handlePreviewFromFileUpload(this.fileUpload, this.isCertificateDefault);
        }
      }
      if (this.sertificateDefaultOnj.typeCertificate === this.signMethod.SIGN_USB_TOKEN) {
        // check connect plugins
        this.blockUI.start('');
        await checkPlugin(this);
        this.current = 2;
        this.isVisible = true;
        if (this.isAllowSelectSignPosition) {
          this.onStamped();
        }
      }
        // else if (this.typeCertificate === this.signMethod.SIGN_OTP && this.allowImage) {
        //   this.current = 0;
        //   this.isVisible = true;
      // }
      else if (this.sertificateDefaultOnj.typeCertificate === this.signMethod.SIGN_NO_CERT && this.allowImage) {
        this.current = 0;
      } else {
        if (this.sertificateDefaultOnj.typeCertificate === this.signMethod.SIGN_OTP
          && this.supportEkyc && this.enterpriseInfo.customerType === EnterpriseTypes.PERSONAL) {
          this.isShowEKYC = true;
          this.validateData();
        }

        this.current = 2;
        if (this.document && this.document.mainContractAttachments) {
          setTimeout(() => {
            const tabs = document.getElementsByClassName('tab');
            if (tabs) {
              Array.from({length: tabs.length}, (v, i) => i).forEach(index => {
                const tab = tabs.item(index) as HTMLElement;
                tab.style.width = 100 / this.document.mainContractAttachments.length + '%';
              })
            }
          }, 100);
        }
        this.isVisible = true;
      }
    }
  }

  validateData() {
    if (this.selectedCert.typeCertificate === 3) {
      if (this.checkOtp) {
        const enterprisePhone = this.digitalCertificateService.formatPhoneNumber(localStorage.getItem('enterprisePhoneProcessing'));
        if (enterprisePhone && (this.selectedCert.phoneNumber !== enterprisePhone)) {
          const message = this.commonService.format(this.message.getMessage('messages.digital_certificate_validate_phone'), enterprisePhone);
          const dialogRe = this.dialog.open(AlertComponent, {
            width: '350px',
            data: message,
          });
          dialogRe.afterClosed().subscribe((rs) => {
            if (rs) {
              this.dialogRef.close();
            }
          });
          this.disableSignBtn = false;
          return;
        }
      }
    }

    //Check Loại giấy tờ
    if (this.isShowEKYC && this.isStillQuantityEkyc && this.supportEkyc && !this.isCertificateSupport) {
      // thông báo lỗi 'digital_certificate_management.certificate_not_support'
      const dialogRe = this.dialog.open(AlertComponent, {
        width: '350px',
        data: this.message.getMessage('digital_certificate_management.certificate_not_support'),
      });
      dialogRe.afterClosed().subscribe((rs) => {
        if (rs) {
          this.dialogRef.close();
        }
      });
      this.disableSignBtn = false;
      return;
    }

    if (this.isShowEKYC && !this.isStillQuantityEkyc && this.supportEkyc) {
      const dialogRe = this.dialog.open(AlertComponent, {
        width: '350px',
        data: this.message.getMessage('digital_certificate_management.quantity_ekyc_not_enough'),
      });
      dialogRe.afterClosed().subscribe((rs) => {
        if (rs) {
          this.dialogRef.close();
        }
      });
      this.disableSignBtn = false;
      return;
    }

    if (this.isShowEKYC && this.supportEkyc) {
      // if (this.ekyc.errors.length > 0) {
      //   const dialogRe = this.dialog.open(AlertComponent, {
      //     width: '350px',
      //     data: this.message.getMessage('kyc.camera_errors'),
      //   });
      //   dialogRe.afterClosed().subscribe((rs) => {
      //     if (rs) {
      //       this.dialogRef.close();
      //     }
      //   });
      //   this.disableSignBtn = false;
      //   return;
      // }
      return;
    }

  }

  preCurentOne() {
    this.current = 0;
    this.indexSelect == 0;
    this.nzSelectChange(0);
    let isShowDefaultTab = this.selectedCert.typeCertificate !== this.signMethod.SIGN_NO_CERT && this.selectedCert.imageUrl;
    const indexUploadTab = isShowDefaultTab ? 2 : 1;
    const indexDrawTab = isShowDefaultTab ? 3 : 2;
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    this.activeFile = 0;
    this.pdfSrc = this.fileSrc.length ? this.fileSrc[0] : null;
    this.isSelectPosition = false;
    this.isAllowSelectSignPosition = false;
    this.isSelectDrawImage = false;
    this.fileUpload = null;
    this.imageUrlPreview = '';
    this.avatarUrl = null;
    if (this.selectedCert) {
      this.isDisableNextButton = false;
    }
    if (this.indexSelect == indexUploadTab || this.indexSelect == indexDrawTab) {
      this.isDisableNextButton = true;
    }
    this.getCertificatesPreOne();
    this.isCertificateDefault = false;
  }

  getCertificatesPreOne() {
    this.digitalCertificateService.getCertificates(this.enterpriseId).subscribe(rs => {
      this.certificates = rs.data;
      if (this.certificates.length > 0) {
        for (const cerType of this.certificates) {
          cerType.listCert = cerType.listCert.map((item) => {
            const {imagePath} = item;
            if (imagePath) {
              const imageDataBlob = this.commonService.b64toBlob(imagePath);
              const blobUrl = URL.createObjectURL(imageDataBlob);
              return {
                ...item,
                imageUrl: blobUrl
              };
            } else {
              return {
                ...item,
                imageUrl: ''
              };
            }
          });
        }
        this.imageCertificates = [
          ...this.certificates
        ];
      }
      // if (this.userType === 5) {
      //   this.imageCertificates = [
      //     ...this.imageCertificates,
      //     {
      //       type: 6,
      //       listCert: [
      //         { typeCertificate: 6 }
      //       ]
      //     }
      //   ];
      // }
      if (this.imageCertificates.length > 0) {
        this.typeCertificate = this.imageCertificates[0].type;
        this.selectedCert = this.imageCertificates[0].listCert[0];
        this.isCheckedFirstCertificate();
        this.isDisableNextButton = false;
      } else {
        this.isDisableNextButton = true;
      }
      this.selectedIndex = 0;
    });
  }

  viewDocumentsUpload(id: string) {
    if (this.document) {
      const firstFile = this.document.mainContractAttachments[0];
      this.pdfSrc = this.listPdfSrc[firstFile.path];
    }

    // return this.commonService.getViewPdfsForDocument(id).subscribe(async (res) => {
    //   if (!res.data) {
    //     return;
    //   }
    //   const fileSrc = [];
    //   const files = [];
    //   for await (const [index, item] of res.data.entries()) {
    //     const file = new Blob([new Uint8Array(item.bytes)], {type: 'application/pdf'});
    //     files.push(file);
    //     const base64 = await this.blobToBinary(file);
    //     fileSrc.push(base64);
    //   }
    //   if (fileSrc.length > 0) {
    //     this.fileSrc = fileSrc;
    //     this.pdfSrc = fileSrc[0];
    //   }
    // });
  }

  loadConfigAndCertificates(role) {
    this.digitalCertificateService.getServiceTypeByContractId(this.contractId, role).subscribe(async (res) => {
      if (res.data) {
        // type = 2 là khách hàng cá nhân mới check
        // if (parseInt(localStorage.getItem('typeAllowCheck')) === 2) {
        res.data.allowImage ? this.allowImage = res.data.allowImage : this.allowImage = false;
        res.data.allowOtp ? this.allowOtp = res.data.allowOtp : this.allowOtp = false;
        // có vấn đề ở đống này

        this.supportEkyc = !!Number(res.data.ekycSupportConfig);
        this.ekycSupportConfig = res.data.ekycSupportConfig;
        if (this.supportEkyc) {
          await this.getQuantityEkyc();
        } else {
          // this.selectFirstCertificate();
        }
        // res.data.checkEkycSupport ? this.supportEkyc = res.data.checkEkycSupport : this.supportEkyc = false;
        // } else {
        //   this.allowImage = false;
        //   this.allowOtp = false;
        // }
        this.checkCertNumber = res.data.checkCertNumber;
        this.checkOtp = res.data.checkOtp;
        this.checkName = res.data.checkName;
        // this.countAllApiBeforeCertificateDefault += 1;
        // this.signFlowDocumentWithCerDefault();
        this.digitalCertificateService.getPermissionHSM(localStorage.getItem('enterpriseId')).subscribe(res => {
          if (res && res.success) {
            this.isHsmPermission = res.data.enableHsm;
            this.getCertificates();
          }
        })
      } else {
        this.toastr.error(this.message.getMessage('messages.error_data_wrong_digital_certificate'));
      }
    }, error => {
      this.toastr.error(this.message.getMessage('messages.error_data_wrong_digital_certificate'));
    });
  }

  blobToBinary(blob: Blob) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.onload = (e: any) => {
        resolve(e.target.result);
      };
      reader.readAsArrayBuffer(blob);
    })
  }

  changeFile(filePath: string, index: number) {
    this.isSelectPosition = false;
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    this.pageCurrent = 1;
    this.activeFile = index;
    //siten cmt: trùng logic với checkSignManual()
    // const id = this.document.mainContractAttachments[index].id;
    // const fileId = this.decodeId(id);
    // const findSign = this.signPosition.filter(sign => {
    //   return sign.fileId === fileId;
    // });
    // if (!findSign.length) {
    //   this.onStamped();
    // }
    this.checkSignManual();
    // if (this.fileSrc.length) {
    //   this.pdfSrc = this.fileSrc[index];
    // }
    if (this.listPdfSrc) {
      this.pdfSrc = this.listPdfSrc[filePath];
    }
  }

  decodeId(id: string) {
    const idDecode = atob(id);
    const findNumber = idDecode.match(/[0-9]{1,}/g);
    if (findNumber && findNumber.length) {
      return Number(findNumber[findNumber.length - 1]);
    }
    return null;
  }

  checkSignManual() {
    const id = this.document.mainContractAttachments[this.activeFile].id;
    const fileId = this.decodeId(id);
    const signs = this.signPosition.filter(sign => {
      return sign.fileId === fileId;
    });
    if (signs.length > 0) {
      this.isAllowSelectSignPosition = false;
      this.isSelectPosition = false;
      if (signs.length === 1 && signs[0].signType === this.signPositionTypes.DIGITAL) {
        this.onlyDigital = true;
      } else {
        this.onlyDigital = false;
      }
      // siten comment do code signType luôn khác COMBINE
      // if (signs.length === 1 && signs[0].signType === this.signPositionTypes.COMBINE) {
      //   this.isAllowSelectSignPosition = true;
      // }
    } else {
      this.isAllowSelectSignPosition = true;
      this.onStamped();
    }
  }

  checkFileNotHaveSign(id: string) {
    return this.fileError.includes(id);
  }

  signCancel() {
    this.userCancel = true
    this.imageData = this.contractSignEntityList;
    const dialog = this.dialog.open(WarningComponent, {
      width: '40%',
      data: this.message.getMessage('sign_processing_dialog.message_stop_sign')
    });
    dialog.afterClosed().subscribe(ref => {
      if (ref) {
        this.isCancel = true;
        this.documentService.setCancelFlow(true);
        const data = {
          signTransactionId: this.signTransactionId,
          userCancel: this.userCancel,
          signMethod: this.selectedCert.typeCertificate,
          contractId: this.document.id,
          mainContractAttachments: [],
          certificate: this.sign.certificate,
          digitalCertificateDetailId: this.selectedCert.idDetail
        };
        this.errorStatus = "messages.stop_sign_document";
        this.userCancel = false
        this.signDocumentService.signCancel(data).subscribe(res => {
          // this.userCancel = false
          // this.errorStatus = "messages.stop_sign_document";
        });
        // this.blockUI.start();
      }
    })
  }

  signClose() {
    // this.imageData = this.contractSignEntityList;
  }

  async processSignOTPAfterDialogClose(signDialog: any, dialog: any, focusInput: any) {
    this.blockUI.reset();
    this.blockUI.start('');
    let signMethod = this.selectedCert.typeCertificate;
    if (this.isShowEKYC) {
      if (this.ekycSupportConfig === 1) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC;
      } else if (this.ekycSupportConfig === 2) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC_ADVANCED;
      }
    }
    const sign = JSON.parse(JSON.stringify(this.sign));
    sign.signTransactionCode = this.commonService.generateUUID();
    sign.otp = signDialog.otp;
    sign.anonymousOtp = false;
    sign.transactionId = signDialog.transactionId;
    sign.contractId = signDialog.contractId;
    sign.signMethod = signMethod;
    sign.message = this.messageSign
    if (this.fileUpload) {
      sign.signPositions = JSON.stringify(this.signProcessing);
      sign.image = this.fileUpload;
      this.getApiSignImageSystem(this.signDocumentService.signOtpWithImageBase64, sign);
    } else {
      sign.signPositions = this.signProcessing;
      this.signDocumentService.signOtpNoImage(sign).toPromise().catch(err => {
        this.errorStatus = this.message.getMessage('messages.sign_fail');
      });
      ;
    }
    this.signingProcess(sign.signTransactionCode, dialog, focusInput);
  }

  // EKYC
  getEnterprise() {
    this.enterpriseService.getDetailCusByEnterprise(this.contractId).subscribe(res => {
      if (res && res.data) {
        this.enterpriseInfo = res.data;
        if (+res.data.certificateId === CertificateTypeID.HO_CHIEU) {
          this.isPassport = true;
        } else if (+res.data.certificateId === CertificateTypeID.CCCD || +res.data.certificateId === CertificateTypeID.CMTND) {
          this.isPassport = false;
        }

        if (+this.enterpriseInfo.certificateId === CertificateTypeID.CCCD
          || +this.enterpriseInfo.certificateId === CertificateTypeID.CMTND
          || +this.enterpriseInfo.certificateId === CertificateTypeID.HO_CHIEU) {
          this.isCertificateSupport = true;
        }
      }
    })
  }

  async getQuantityEkyc() {
    if (!this.contractId) return of(null);
    const res = await this.signDocumentService.getQuantityEkyc(this.contractId).toPromise()
    if (res.success === true && res.data) {
      if (this.ekycSupportConfig == 1 && res.data.quantityEkyc) this.isStillQuantityEkyc = true; //normal
      if (this.ekycSupportConfig == 2 && res.data.quantityAdvancedEkyc) this.isStillQuantityEkyc = true; //Advance
      if (res.data.quantityEkyc) this.isQuantityEkyc = true;
      if (res.data.quantityAdvancedEkyc) this.isQuantityAdvancedEkyc = true;
    } else {
      this.toastr.error(this.message.getMessage(res.message));
    }
    // console.log("🚀 ~ file: sign-flow-document.component.ts ~ line 2167 ~ this.isStillQuantityEkyc", this.isStillQuantityEkyc)
    // if (!this.selectedCert.typeCertificate) {
    // this.selectFirstCertificate();
    // }
  }

  getQuantityEkycBeforeNext(): Observable<boolean> {
    this.blockUI.start('');
    return this.signDocumentService.getQuantityEkyc(this.contractId)
      .pipe(map((res) => {
        let isNext = false;
        this.blockUI.stop();
        if (res.success === true && res.data) {
          if (this.ekycSupportConfig == 1 && res.data.quantityEkyc) isNext = true; //normal
          if (this.ekycSupportConfig == 2 && res.data.quantityAdvancedEkyc) isNext = true; //Advance
        } else {
          this.toastr.error(this.message.getMessage(res.message));
        }
        return isNext
      }))

  }

  openDialogOutOfMoneyOtp(message) {
    const confirmDialog = this.dialog.open(NotifyWarningComponent, {
      data: message
    });
  }

  checkTimestampMoney() {

    this.isClickSignBuuton = true;
    if (this.isSelectPosition && this.isShowImage) {
      this.toastr.error(this.message.getMessage('messages.need_choose_position'));
      this.blockUI.stop();
      return;
    }

    // tab vẽ chữ ký: chặn ký khi nét vẽ mới chưa được Áp dụng
    if (this.isSelectDrawImage && !this.canvasService.isApplyDrawSignatureValue && this.isShowImage) {
      this.toastr.error(this.message.getMessage('validation.draw_sign_valid_empty'));
      this.blockUI.stop();
      return;
    }

    // kiem tra file da ky day du chua
    if (this.document.mainContractAttachments && this.document.mainContractAttachments.length && this.isShowImage) {

      const fileName = [];
      let indexError = null;
      let filePathError = null;
      const fileError = [];
      this.document.mainContractAttachments.forEach((ca, index) => {
        const fileId = this.decodeId(ca.id);
        // xoa digital khi ki co image
        const hasImage = this.signPosition.some(e => e.signType === SignPositionTypes.IMAGE);
        const sign = this.signPosition.filter(signData => {
          if (signData.fileId === fileId) {
            if (hasImage) {
              if (signData.signType !== SignPositionTypes.DIGITAL) {
                return signData;
              }
            } else {
              return signData;
            }
          }

        });
        if (!sign.length) {
          if (!indexError) {
            indexError = index;
            filePathError = ca.path
          }
          fileError.push(ca.id);
          fileName.push(`'${ca.fileName}'`);
        }
      });

      if (this.document.status === EnumContractStatus.CANCELLED) {
        this.toastr.error(this.commonService.format(this.message.getMessage('messages.cancel_sign_flow_with_contract'), fileName.join(', ')).replace(/&quot;/g, "'"));
        this.blockUI.stop();
        return;
      }

      if (fileName.length) {
        this.changeFile(filePathError, indexError);
        this.fileError = fileError;
        this.toastr.error(this.commonService.format(this.message.getMessage('messages.need_create_sign_file'), fileName.join(', ')).replace(/&quot;/g, "'"));
        this.blockUI.stop();
        return;
      }
    }
    if (this.saveImageData.length == 0) {
      this.saveImageData = _.cloneDeep(this.imageData);
    } else
      this.imageData = this.saveImageData;

    this.sign = {
      contractId: this.contractId,
      digitalCertificateId: this.selectedCert.id,
      digitalCertificateDetailId: this.selectedCert.idDetail,
      ...this.selectedCert
    };
    let preImageSort = [];

    for (const contractAttachment of this.document.mainContractAttachments) {
      const fileId = this.decodeId(contractAttachment.id);
      const hasImage = this.imageData.some(e => e.signType === SignPositionTypes.IMAGE);
      const imageData = this.imageData.filter(signDataImage => {
        if (signDataImage.fileId === fileId) {
          if (hasImage) {
            if (signDataImage.signType !== SignPositionTypes.DIGITAL) {
              return signDataImage;
            }
          } else {
            return signDataImage;
          }
        }

      });
      preImageSort = preImageSort.concat(imageData);
    }
    const imageSort = _.cloneDeep(preImageSort);
    let imageData = []
    const arr1 = [];
    for (let i = 0; i < imageSort.length; i++) {
      for (let j = 0; j < imageSort.length; j++) {
        if (i !== j && imageSort[j].positionX == imageSort[i].positionX
          && imageSort[j].positionY == imageSort[i].positionY
          && imageSort[j].pageNumber == imageSort[i].pageNumber
          && imageSort[j].widthRectangle == imageSort[i].widthRectangle
          && imageSort[j].heightRectangle == imageSort[i].heightRectangle
          && imageSort[j].zoom == imageSort[i].zoom
          && imageSort[j].fileId == imageSort[i].fileId
          && imageSort[j].signType !== imageSort[i].signType) {
          if (imageSort[j].signType == 'image') {
            arr1.push(imageSort[j])
          } else {
            arr1.push(imageSort[i])
          }
          imageSort.splice(j, 1);
          imageSort.splice(i, 1);
          i--;
          break;
        }
      }
    }
    imageData = ([...imageSort, ...arr1]);
    let imagePreSort = [];
    const mapFileCodes = FileUtils.getCodeOfFileWhenSignOnce(this.document.mainContractAttachments);
    for (const contractAttachment of this.document.mainContractAttachments) {
      const fileId = this.decodeId(contractAttachment.id);
      if (!this.isShowImage) {
        let imageList = [
          {
            positionX: 1,
            positionY: 1,
            pageNumber: 1,
            signType: "image",
            widthRectangle: 0,
            heightRectangle: 0,
            zoom: 1,
            fileId: fileId,
          }
        ]
        imagePreSort = imagePreSort.concat(imageList);
      } else {
        let imageList = imageData.filter(item => {
          return item.fileId === fileId
        });
        imageList = imageList.sort((a, b) => a.pageNumber === b.pageNumber ?
          Number(b.positionY) - Number(a.positionY) :
          Number(a.pageNumber) - Number(b.pageNumber));
        imagePreSort = imagePreSort.concat(imageList);
      }
    }
    this.signImages = imagePreSort.map((item) => {
      item['code'] = mapFileCodes.get(item.fileId);
      return item;
    });
    this.signProcessing = JSON.parse(JSON.stringify(this.signImages));
    if (this.current === 3 && this.isShowEKYC) {
      this.onIdentityEKYC();
    } else if (this.selectedCert.typeCertificate === this.signMethod.SIGN_OTP) {
      if (this.isShowEKYC && this.current === 2) {
        this.onNextEKYC()
      } else {
        this.processSignOTP()
      }
      // }else if(this.selectedCert.typeCertificate === this.signMethod.SIGN_USB_TOKEN){
      //   this.isCallDone = true;
      //   initPluginCertificateNormal(this);
    } else {
      this.blockUI.reset();
      this.blockUI.start('');
      if (this.selectedCert.typeCertificate === this.signMethod.SIGN_SERVER) {
        this.digitalCertificateService.getPermissionHSM(localStorage.getItem('enterpriseId')).subscribe(res => {
          if (res.data.enableHsm) {
            if (this.document.isConfirmBCT && this.selectedCert.typeCertificate !== this.signMethod.SIGN_USB_TOKEN) {
              let body = {};
              if (this.roleApprover == '2') {
                this.signImages.forEach(rs => {
                  rs.isSignDigitalCertificate = this.isSignDigitalCertificate;
                });
                body = {
                  signMethod: this.selectedCert.typeCertificate,
                  contractId: this.contractId,
                  signPositions: this.signImages
                };
              } else {
                body = {
                  signMethod: this.selectedCert.typeCertificate,
                  contractId: this.contractId,
                  signPositions: this.signImages
                };
              }
              this.documentService.createTimestampMoney(body).subscribe(
                res => {
                  this.blockUI.stop();
                  if (res && !res.success) {
                    if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
                      this.openDialogOutOfMoneyOtp(this.message.getMessage('digital_certificate_management.out_of_money_timestamp'));
                    else
                      this.toastr.error(res.message)
                  } else {
                    this.signTransactionId = res.data;
                    this.onClickSignButton()
                  }
                }
              )
            } else {
              this.blockUI.reset();
              this.blockUI.start('');
              if (this.document.isConfirmBCT) {
                let body = {};
                if (this.roleApprover == '2') {
                  this.signImages.forEach(rs => {
                    rs.isSignDigitalCertificate = this.isSignDigitalCertificate;
                  });
                  body = {
                    signMethod: this.selectedCert.typeCertificate,
                    contractId: this.contractId,
                    signPositions: this.signImages
                  };
                } else {
                  body = {
                    signMethod: this.selectedCert.typeCertificate,
                    contractId: this.contractId,
                    signPositions: this.signImages
                  };
                }
                this.documentService.createTimestampMoney(body).subscribe(
                  res => {
                    this.blockUI.stop();
                    if (res && !res.success) {
                      if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
                        this.openDialogOutOfMoneyOtp(this.message.getMessage('digital_certificate_management.out_of_money_timestamp'));
                      else
                        this.toastr.error(res.message)
                    } else {
                      this.signTransactionId = res.data;
                      this.onClickSignButton()
                    }
                  }
                )
              } else {
                this.signImages = imagePreSort;
                this.blockUI.stop();
                this.onClickSignButton();
              }
            }
          } else {
            this.toastr.error(this.message.getMessage('messages.not_hsm_permission'))
          }
        })
      } else {
        if (this.document.isConfirmBCT && this.selectedCert.typeCertificate !== this.signMethod.SIGN_USB_TOKEN) {
          let body = {};
          if (this.roleApprover == '2') {
            this.signImages.forEach(rs => {
              rs.isSignDigitalCertificate = this.isSignDigitalCertificate;
            });
            body = {
              signMethod: this.selectedCert.typeCertificate,
              contractId: this.contractId,
              signPositions: this.signImages
            };
          } else {
            body = {
              signMethod: this.selectedCert.typeCertificate,
              contractId: this.contractId,
              signPositions: this.signImages
            };
          }
          this.documentService.createTimestampMoney(body).subscribe(
            res => {
              this.blockUI.stop();
              if (res && !res.success) {
                if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
                  this.openDialogOutOfMoneyOtp(this.message.getMessage('digital_certificate_management.out_of_money_timestamp'));
                else
                  this.toastr.error(res.message)
              } else {
                this.signTransactionId = res.data;
                this.onClickSignButton()
              }
            }
          )
        } else {
          this.blockUI.reset();
          this.blockUI.start('');
          if (this.document.isConfirmBCT) {
            let body = {};
            if (this.roleApprover == '2') {
              this.signImages.forEach(rs => {
                rs.isSignDigitalCertificate = this.isSignDigitalCertificate;
              });
              body = {
                signMethod: this.selectedCert.typeCertificate,
                contractId: this.contractId,
                signPositions: this.signImages
              };
            } else {
              body = {
                signMethod: this.selectedCert.typeCertificate,
                contractId: this.contractId,
                signPositions: this.signImages
              };
            }
            this.documentService.createTimestampMoney(body).subscribe(
              res => {
                this.blockUI.stop();
                if (res && !res.success) {
                  if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
                    this.openDialogOutOfMoneyOtp(this.message.getMessage('digital_certificate_management.out_of_money_timestamp'));
                  else
                    this.toastr.error(res.message)
                } else {
                  this.signTransactionId = res.data;
                  this.onClickSignButton()
                }
              }
            )
          } else {
            this.signImages = imagePreSort;
            this.blockUI.stop();
            this.onClickSignButton();
          }
        }
      }
    }
  }

  // Hàm xử lý lấy kết quả phiên ký liên tục mỗi 2s
  signingProcess(signTransactionCode, dialog?: any, focusInput?: any) {
    setTimeout(() => {
      this.signingInteval = setInterval(() => {
        this.signDocumentService.getStatusSign({signTransactionCode: signTransactionCode}).subscribe(rs => {
          if (rs && rs.success && rs.data && (rs.data.status == 'DONE' || rs.data.status == 'DAEMON_PROCESSING')) {
            this.isCallDone = true;
            this.signDocumentService.openSigningDialog.next(false);
            clearInterval(this.signingInteval);
            this.onSignSuccess();
          } else if (rs && rs.success && rs.data && rs.data.status !== 'ERROR') {
            let arrayStatus = {};
            if (!this.openSigningDialog && this.selectedCert.typeCertificate === this.signMethod.SIGN_OTP && rs.data.list[0].status == 'DONE') {
              this.blockUI.stop();
              this.signDocumentService.openSigningDialog.next(true);
              dialog.close(true);
            }
            for (let i = 0; i < rs.data.list.length; i++) {
              arrayStatus[rs.data.list[i].code] = rs.data.list[i].status;
            }
            for (let i = 0; i < this.signProcessing.length; i++) {
              this.signProcessing[i].done = arrayStatus[this.signProcessing[i].code] == 'DONE' || arrayStatus[this.signProcessing[i].code] == 'DAEMON_PROCESSING' ? true : false
            }
          } else if (rs.data && rs.data.status === 'ERROR') {
            //dừng xử lý và thông báo lỗi khi ký otp
            if (!this.openSigningDialog && this.selectedCert.typeCertificate === this.signMethod.SIGN_OTP) {
              this.toastr.error(rs.data.message);
              this.blockUI.stop();
              focusInput();
            } else {
              this.signDocumentService.openSigningDialog.next(false);
              this.errorStatus = "messages.stop_sign_document";
              this.signError = rs && rs.data.message ? rs.data.message : null;
            }
            clearInterval(this.signingInteval);
          }
        })
      }, 2000)
    }, 1000);
  }

  disableNextButton() {
    if (this.current === 1) {
      if (this.selectedCert.typeCertificate !== this.signMethod.SIGN_NO_CERT && this.systemImageSign) {
        if (this.imageSignConfig
          && (
            !this.imageSignConfig.allValid()
            || this.imageSignConfig.allValid() === 'non-check'
          )) {
          return true;
        }
      }
    }
    return this.isDisableNextButton || (this.selectedCert.typeCertificate == undefined)
  }

  getConfigKeyList(): string[] {
    return Object.keys(this.signConfig);
  }

  getUserConfig() {
    this.signDocumentService.getUserConfigAsync()
      .pipe(tap(res => {
          if (res.success && res.data) {
            for (const key in this.signConfig) {
              this.signConfig[key].enabled = res.data[key] || false;
            }

            this.signConfig.address.value = res.data['addressDetail'] || '';
            this.signConfig.position.value = res.data['positionDetail'] || '';
            this.signConfig.confirmBy.value = res.data['signature'] || '';
            this.signConfig.fontFamily.value = res.data['fontFamily'] || '';
            this.signConfig.fontWeight.value = res.data['fontWeight'] || '';
            this.signConfig.fontStyle.value = res.data['fontStyle'] || '';
            this.signConfig.signatureImageBase64.value = res.data['signatureImageBase64'] || '';
            this.signConfig.signatureImageName.value = res.data['signatureImageName'] || '';
            this.signConfig.signaturePosition.value = res.data['signaturePosition'] || '';
            this.signConfig.signatureRatio.value = res.data['signatureRatio'] || '';

            this.signConfig.fontFamily.enabled = false;
            this.signConfig.fontWeight.enabled = false;
            this.signConfig.fontStyle.enabled = false;
            this.signConfig.signatureImageBase64.enabled = false;
            this.signConfig.signatureImageName.enabled = false;
            this.signConfig.signaturePosition.enabled = false;
            this.signConfig.signatureRatio.enabled = false;

            this.signConfig.contentPosition.value = res.data['contentPosition'];
            this.signConfig.contentPosition.enabled = false;

            // console.log(this.signConfig);
            // console.log(res.data);
          }
        }),
        switchMap(() => {
          return forkJoin({
            email: this.signDocumentService.getEmailAsync(),
            date: this.signDocumentService.getDateAsync()
          });
        })
      ).subscribe(res => {
        if (res) {
          this.signConfig.signingTime.value = res.date.success ? res.date.data.date : ''
          this.signConfig.email.value = res.email.success ? res.email.data : ''
  
        this.cd.detectChanges();
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      }
    })
  }

  showConfig(key: string): boolean {
    if (key === 'greenTick') {
      return false
    }

    if (this.selectedCert.typeCertificate !== this.signMethod.SIGN_OTP) {
      if (key === 'phoneNumber') {
        this.signConfig.phoneNumber.enabled = false;
        return false;
      }
      if (key === 'confirmBy') {
        this.signConfig.confirmBy.enabled = false;
        return false;
      }
    } else {
      if (key === 'confirmBy' && this.scopeType !== 2) {
        this.signConfig.confirmBy.enabled = true;
        return true;
      } else if (key === 'confirmBy' && this.scopeType === 2) {
        this.signConfig.confirmBy.enabled = false;
        return false;
      }
    }

    return this.signConfig[key].enabled;
  }

  getApiSignImageSystem(api: any, body) {
    if (this.systemImageSign && this.fileUpload) {
      this.signDocumentService.getDateAsync().subscribe(date => {
        this.signConfig.signingTime.value = date.data.date;

        this.cd.detectChanges();

        setTimeout(async () => {
          // let imageSize = this.setSizeFrameImage();
          // this.imageGenerateService.genImage(this.signConfig, imageSize).subscribe(async (rs) => {
          //   const file = new File([rs], 'lastImage.png', {type: 'image/png'});
          //   this.fileUpload = file;
          //   body.image = this.fileUpload;
          //   api(body).subscribe(() => {
          //   }, () => {
          //     this.errorStatus = this.message.getMessage('messages.sign_fail');
          //   })
          // });

          let blob = null;
          try {
            let imageSize = this.setSizeFrameImage();
            blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
          } catch (e) {
            console.log("call api error, use html to image", e);
            try {
              let imageSize = this.setSizeFrameImage();
              blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
            } catch (e) {
              console.log("call api error, use html to image", e);
            }
          }

          if(!blob){
            this.errorStatus = this.message.getMessage('messages.error_proccessing');
            return;
          }

          const file = new File([blob], 'lastImage.png', {type: 'image/png'});
          this.fileUpload = file;
          body.image = this.fileUpload;
          this.invokeSignApi(api, body)


          // htmlToImage.toBlob(this.domRenderImage.nativeElement).then(blob => {
          //   const file = new File([blob], 'lastImage.png', { type: 'image/png' });
          //   this.fileUpload = file;
          //
          //   body.image = this.fileUpload;
          //
          //   api(body).subscribe(() => { }, () => {
          //     this.errorStatus = this.message.getMessage('messages.sign_fail');
          //   })
          // })
        }, 300)
      })
    } else {
      this.invokeSignApi(api, body)
    }
  }

  // hàm cũ trả Observable, hàm Base64 trả Promise — gọi thống nhất ở đây
  invokeSignApi(api: any, body) {
    const rs = api(body);
    if (rs && typeof rs.subscribe === 'function') {
      rs.subscribe(() => {
      }, () => {
        this.errorStatus = this.message.getMessage('messages.sign_fail');
      });
    } else {
      rs.then(() => {
      }).catch(() => {
        this.errorStatus = this.message.getMessage('messages.sign_fail');
      });
    }
  }

  setDataSignConfig(signConfig: any) {
    let newDataSignConfig = {...signConfig};
    if (newDataSignConfig.resize === null || newDataSignConfig.resize === undefined) {
      newDataSignConfig = {...newDataSignConfig, resize: false};
    }
    if (newDataSignConfig.showImage === null || newDataSignConfig.showImage === undefined) {
      newDataSignConfig = {...newDataSignConfig, showImage: true};
    }
    return newDataSignConfig;
  }

  getNumber(value: any) {
    return value.split(':') || [];
  }

  setSizeFrameImage() {
    switch (this.signConfig.signaturePosition.value) {
      case 'left':
      case 'right':
        return {
          width: '370px',
          height: '136px'
        };
      case 'top':
      case 'bottom':
        return {
          width: '300px',
          height: '237px'
        };

      default:
        return {
          width: '300px',
          height: '136px'
        };
    }
  }

  setFontSize(id: string) {
    const listElement: any = document.getElementsByClassName(id);
    // console.log(listElement);
    for (const el of listElement) {
      this.setSizetext(id, el);
    }
  }

  setSizetext(id: string, el: any) {
    if (!el) {
      return;
    }
    el.style.wordBreak = 'break-word';
    if (id === imageConfigViewScaleId) {
      if (el && el.lastElementChild && el.lastElementChild.lastElementChild)
        el = el.lastElementChild.lastElementChild as HTMLElement;
    }

    if (el) {
      let fontSize = 56;
      let minSize = 32;
      let padding = 40;
      if (id === imageConfigFormPreviewId) {
        fontSize /= 4;
        minSize /= 4;
        padding /= 4;
      }

      // console.log(el);
      el.style.fontSize = fontSize + 'px';

      let parent;
      if (this.signConfig.signaturePosition.value === 'top' || this.signConfig.signaturePosition.value === 'bottom') {
        parent = el.parentElement;
      } else {
        parent = el.parentElement.parentElement;
      }
      const parentHeight = parent.offsetHeight;
      let height = el.offsetHeight;

      while (height > parentHeight - padding && fontSize > minSize) {
        if (id === imageConfigFormPreviewId) {
          fontSize -= 1 / 4;
        } else {
          fontSize--;
        }
        el.style.fontSize = fontSize + 'px';
        height = el.offsetHeight;
      }
    }
  }
}
